<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>

        <div
          class="col-24 col-md-11 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5"
        >
          <div class="col d-column">
            <input
              class="input-none"
              id="inputIdReport"
              :value="reportData._id"
            />
            <h6 @click="copyIdReport(reportData._id)" class="pointer">
              <span
                v-if="reportData.status == 'open'"
                class="badge badge-lg badge-warning mr-2 align-self-center mt-1 pb-1 d-inline-block"
                >#{{ reportData._id }}</span
              >
              <span
                v-if="reportData.status == 'closed'"
                class="badge badge-lg badge-success mr-2 align-self-center mt-1 pb-1 d-inline-block"
                >#{{ reportData._id }}</span
              >
            </h6>

            <div class="flex d-flex">
              <h1 class="title pt-2 title-width" v-text="reportData.title"></h1>
              <span
                v-if="reportData.locker"
                class="ico mx-2 mt-2 border ico-vault"
              >
                <img src="../../../src/assets/icons/vault.png" class="ico-20" />
              </span>
            </div>

            <div class="title pb-4">
              <span v-if="reportData.createdAt">{{
                $utils.formatDataLong(reportData.createdAt)
              }}</span>
            </div>

            <div v-if="programData" class="card card-body mb-3">
              <div class="d-column flex-row">
                <div
                  class="h-profile h-profile-lg no d-flex align-self-start d-flex flex-row align-items-start justify-content-start w-100"
                >
                  <div style="width: 75px">
                    <object
                      width="62"
                      height="62"
                      class="rounded-circle img-lg mr-3"
                      :data="programData.avatar"
                      type="image/png"
                    >
                      <img
                        width="62"
                        height="62"
                        class="rounded-circle img-lg mr-3"
                        src="../../assets/images/default.png"
                        alt="Avatar"
                      />
                    </object>
                  </div>
                  <div class="pl-2 d-flex w-100">
                    <div class="align-self-start mt-1 w-100">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center">
                          <h3 class="pb-1">
                            <a
                              :href="'/program/detail?' + programData.id"
                              class="link-block"
                              ><strong v-text="programData.name"></strong
                            ></a>
                          </h3>
                          <ScoreMultiplierIcon
                            class="ml-2 mb-1"
                            v-if="programData.offers_bonus_score"
                            :bonus-score-value="programData.bonus_score_value"
                          />
                        </div>

                        <div v-if="this.possibleDup || this.possibleSpam">
                          <VueCustomTooltip
                            :label="
                              $ml
                                .with('scope', reportData.scope_description)
                                .with('CWE', reportData.weakness_external_id)
                                .get('possibleDup')
                            "
                            v-if="this.possibleDup"
                            style="right: 0"
                          >
                            <span
                              class="badge badge-warning text-white"
                              v-text="$ml.get('duplicated')"
                            >
                              Duplicado
                            </span>
                          </VueCustomTooltip>
                          <VueCustomTooltip
                            :label="
                              $ml
                                .with('scope', reportData.scope_description)
                                .with('CWE', reportData.weakness_external_id)
                                .with('expert', reportData.hacker_username)
                                .get('possibleSpam')
                            "
                            v-if="this.possibleSpam"
                            style="margin-left: 10px; right: 0"
                          >
                            <span class="badge badge-warning text-white">
                              Spam
                            </span>
                          </VueCustomTooltip>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between">
                        <p class="d-flex align-items-center">
                          <span
                            class="align-self-center"
                            v-text="
                              $ml
                                .with(
                                  $utils.formatData(
                                    programData.createdAt,
                                    $ml.get('ln'),
                                  ),
                                )
                                .get('publishedDaysAgo')
                            "
                          >
                          </span>
                        </p>
                        <div
                          class="d-flex align-items-center c-double-bounty"
                          v-if="
                            active_campaign && !double_score && double_bounty
                          "
                        >
                          <img
                            src="../../assets/icons/double-bounty-icon.png"
                            width="36"
                            height="36"
                          />
                          <p
                            v-text="$ml.get('doubleReward')"
                            style="font-weight: 400; color: #730e9f"
                          >
                            Recompensa em dobro
                          </p>
                        </div>
                        <div
                          class="d-flex align-items-center c-double-bounty"
                          v-if="
                            active_campaign && double_score && !double_bounty
                          "
                        >
                          <img
                            src="../../assets/icons/score-fill.svg"
                            width="28"
                            height="28"
                          />
                          <p
                            v-text="$ml.get('doubleScore')"
                            style="font-weight: 400; color: #730e9f"
                          >
                            Pontuação em dobro
                          </p>
                        </div>
                        <div
                          class="d-flex align-items-center c-double-bounty"
                          v-if="
                            active_campaign && double_score && double_bounty
                          "
                        >
                          <img
                            src="../../assets/icons/bounty-score-fill.svg"
                            width="28"
                            height="28"
                          />
                          <p
                            v-text="$ml.get('doubleScoreAndBounty')"
                            style="font-weight: 400; color: #730e9f"
                          >
                            Recompensas e pontuação dobradas
                          </p>
                        </div>
                      </div>
                      <hr />
                      <div class="card-chart-body w-100">
                        <div class="row">
                          <div
                            :class="
                              cvss
                                ? 'col-4 border-r-d mb-2'
                                : 'col-6 border-r-d mb-2'
                            "
                          >
                            <span class="pb-1">Status</span>
                            <h6>
                              <a
                                v-if="reportData.status"
                                v-text="$ml.get(reportData.status)"
                              ></a>
                            </h6>
                          </div>

                          <div
                            :class="
                              cvss
                                ? 'col-5 border-r-d pl-3 mb-2'
                                : 'col-6 border-r-d pl-3 mb-2'
                            "
                          >
                            <span class="pb-1" v-text="$ml.get('situation')"
                              >Situação</span
                            >
                            <h6>
                              <a
                                v-if="reportData.situation"
                                class="text-capitalize text-dark"
                                v-text="$ml.get(reportData.situation)"
                              >
                              </a>
                            </h6>
                          </div>

                          <div
                            :class="
                              cvss
                                ? 'col-5 border-r-d pl-3 mb-2 wrap-wo'
                                : 'col-6 border-r-d pl-3 mb-2 wrap-wo'
                            "
                          >
                            <span class="pb-1" v-text="$ml.get('threats')"
                              >Ameaças</span
                            >
                            <tbody>
                              <tr>
                                <VueCustomTooltip
                                  :label="reportData.weakness_type"
                                >
                                  <td>
                                    <span
                                      class="badge badge-secondary"
                                      v-text="
                                        reportData.weakness_external_id
                                          ? reportData.weakness_external_id
                                          : $ml.get('uninformed')
                                      "
                                    >
                                    </span>
                                  </td>
                                </VueCustomTooltip>
                              </tr>
                            </tbody>
                          </div>

                          <div
                            :class="
                              cvss ? 'col-10 pl-3 mb-2' : 'col-6 pl-3 mb-2'
                            "
                          >
                            <span class="pb-1">{{ $ml.get("severity") }} </span>
                            <div class="row">
                              <Impact
                                :impact="'impact-' + reportData.severity"
                                class="mt-1 mr-1"
                              />
                              <b v-if="cvss"
                                >{{ $ml.get(reportData.severity) }} -
                                {{ cvssScore }}</b
                              >
                            </div>
                            <p v-if="cvss" class="mb-2 mt-1">
                              CVSS 3.1 - {{ cvss }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <hr v-if="$store.getters['getUserType'] == 'company'" />
                      <div
                        class="card-chart-body w-100"
                        v-if="$store.getters['getUserType'] == 'company'"
                      >
                        <div class="row">
                          <div class="col-24 mb-2" @click="addtags()">
                            <h6 class="pb-1 pointer" style="color: #730ca8">
                              Tags
                              <img
                                src="../../assets/icons/plus-circle-pink.svg"
                                width="16"
                                height="16"
                              />
                            </h6>

                            <div class="d-flex flex-row">
                              <ul
                                class="b-form-tags-list list-unstyled mb-0 d-flex flex-wrap inputTags"
                                style="gap: 5px"
                              >
                                <li
                                  v-for="(tag, index) in tags"
                                  :key="index"
                                  class="tagsListReport mw-100 mr-2"
                                >
                                  <span class="flex-grow-1">{{
                                    $utils.capitalizeFirstLetter(tag)
                                  }}</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="reportData.createdAt" class="card card-no mb-3">
              <div class="d-column flex-row">
                <div
                  class="h-form h-profile-lg d-flex w-100 flex-column pb-3 align-items-center no"
                  id="reportHeight"
                >
                  <div class="row w-100">
                    <div class="d-flex align-self-start mt-4">
                      <div
                        class="position-relative d-flex align-items-center align-self-center"
                      >
                        <object
                          width="42"
                          height="42"
                          class="rounded-circle img-m"
                          :data="reportData.hacker_avatar"
                          type="image/png"
                        >
                          <img
                            width="42"
                            height="42"
                            class="rounded-circle img-m"
                            src="../../assets/images/default.png"
                            alt="Avatar"
                          />
                        </object>
                        <div v-show="reportData.hacker_verified" class="verify">
                          <img
                            src="../../../src/assets/icons/badge-check.png"
                            width="16"
                            height="16"
                          />
                        </div>
                      </div>
                      <div class="pl-3 d-flex">
                        <div class="align-self-start mt-1">
                          <h3 class="m-0">
                            <a
                              v-text="
                                reportData.deleted_author
                                  ? $ml.get('userRemoved')
                                  : reportData.hacker_username
                              "
                            ></a
                            >&nbsp;
                            <font v-text="$ml.get('sentTheReport')"
                              >enviou o relatório</font
                            ><br />
                            <div
                              v-if="$store.getters['getUserType'] == 'company'"
                              class="pt-2 align-items-center d-flex"
                            >
                              <div class="row">
                                <h6
                                  class="badge bg-ranking text-white mr-2 p-1 px-2"
                                >
                                  {{
                                    reportData.hacker_ranking > 0
                                      ? $ml
                                          .with(reportData.hacker_ranking)
                                          .get("rankingPosition")
                                      : $ml.get("undefinedRanking")
                                  }}
                                </h6>
                              </div>
                              <div class="row">
                                <h6 style="color: #a9a09e">
                                  {{ reportData.hacker_score }}
                                  {{ $ml.get("points") }}
                                </h6>
                              </div>
                            </div>
                          </h3>
                        </div>
                      </div>
                    </div>

                    <div
                      class="d-flex align-items-center justify-content-end col"
                      v-if="$store.getters['getUserType'] == 'company'"
                    >
                      <VueCustomTooltip label="Download">
                        <h6
                          class="pointer"
                          @click="$bvModal.show('modal-password')"
                        >
                          <img
                            style="border-radius: 3px !important"
                            width="20"
                            height="20"
                            src="../../assets/icons/download.svg"
                          />
                        </h6>
                      </VueCustomTooltip>
                    </div>
                  </div>

                  <!-- Target Report -->
                  <div v-if="target" class="align-self-start w-100">
                    <div class="d-flex align-self-start v-line">
                      <span class="pb-4"></span>
                    </div>

                    <div class="d-flex align-self-start h-profile-circle">
                      <div class="circle d-flex justify-content-center">
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-primary"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span></span></div>
                      </div>
                      <div class="d-flex flex-column w-100 mr-3">
                        <div class="position-relative">
                          <p class="pl-3 mb-3">
                            <strong v-text="$ml.get('target')">Objetivo</strong>
                          </p>
                          <svg
                            v-if="
                              $utils.convertMarkedOld(target.policy) !=
                              $utils.convertMarkedOld(target.translated_policy)
                            "
                            v-b-tooltip.hover
                            :title="$ml.get('seeOriginalText')"
                            @click="
                              showOriginalPolicyTarget =
                                !showOriginalPolicyTarget
                            "
                            width="25"
                            height="25"
                            class="mx-2 icon-summary"
                          >
                            <image
                              xlink:href="../../../src/assets/svg/aa.svg"
                              width="25"
                              height="25"
                            />
                          </svg>
                        </div>
                        <div class="card ml-3 d-flex w-100">
                          <div class="card-header">{{ target.title }}</div>
                          <div class="card-body pr-3 pl-3">
                            <div class="row">
                              <div class="col">
                                <p
                                  v-if="showOriginalPolicyTarget"
                                  v-html="
                                    $utils.convertMarkedOld(
                                      target.translated_policy,
                                    )
                                  "
                                ></p>
                                <p
                                  v-else
                                  v-html="
                                    $utils.convertMarkedOld(target.policy)
                                  "
                                ></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Item Summary -->
                  <div
                    v-if="reportData.abstract"
                    class="align-self-start w-100"
                  >
                    <div class="d-flex align-self-start v-line">
                      <span class="pb-4"></span>
                    </div>

                    <div class="d-flex align-self-start h-profile-circle">
                      <div class="circle d-flex justify-content-center">
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-primary"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span></span></div>
                      </div>
                      <div class="d-flex flex-column w-100 mr-3">
                        <div class="position-relative">
                          <p class="pl-3 mb-3">
                            <strong v-text="$ml.get('summary')">Sumário</strong>
                          </p>
                          <svg
                            v-if="
                              $utils.convertMarkedOld(
                                decodeBase64(reportData.abstract),
                              ) !=
                              $utils.convertMarkedOld(
                                decodeBase64(reportData.translated_abstract),
                              )
                            "
                            v-b-tooltip.hover
                            :title="$ml.get('seeOriginalText')"
                            @click="showOriginalSummary = !showOriginalSummary"
                            width="25"
                            height="25"
                            class="mx-2 icon-summary"
                          >
                            <image
                              xlink:href="../../../src/assets/svg/aa.svg"
                              width="25"
                              height="25"
                            />
                          </svg>
                        </div>
                        <div class="card card-body ml-3 pl-3 d-flex w-100 pr-3">
                          <div class="row">
                            <div class="col">
                              <div
                                class="form-group"
                                v-text="
                                  showOriginalSummary
                                    ? reportData.abstract
                                    : reportData.translated_abstract
                                "
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Item Scope -->
                  <div
                    v-if="reportData.scope_description"
                    class="align-self-start w-100"
                  >
                    <div class="d-flex align-self-start v-line">
                      <span class="pb-4"></span>
                    </div>

                    <div class="d-flex align-self-start h-profile-circle">
                      <div class="circle d-flex justify-content-center">
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-primary"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span></span></div>
                      </div>
                      <div class="d-flex flex-column w-100 mr-3">
                        <div class="card card-body ml-3 p-0 d-flex w-100">
                          <table class="mb-2">
                            <thead>
                              <tr>
                                <th class="col-11" v-text="$ml.get('scope')">
                                  Escopo
                                </th>
                                <th class="col-8 pl-0" v-text="$ml.get('type')">
                                  <p></p>
                                  Tipo
                                </th>
                                <th class="col-5 pl-0"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="col-11">
                                  <strong
                                    class="wb-bw fs-16"
                                    v-text="reportData.scope_description"
                                  ></strong>
                                </td>
                                <td
                                  class="col-8 pl-0 text-muted fs-16"
                                  v-text="nameLangScope(reportData.scope_type)"
                                ></td>
                                <td class="col-5 pl-0">
                                  <Impact
                                    v-if="reportData.scope_severity"
                                    :impact="
                                      'impact-' + reportData.scope_severity
                                    "
                                    class="d-flex mt-1"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="reportData.alternativeScope"
                    class="align-self-start w-100"
                  >
                    <div class="d-flex align-self-start v-line">
                      <span class="pb-4"></span>
                    </div>

                    <div class="d-flex align-self-start h-profile-circle">
                      <div class="circle d-flex justify-content-center">
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-primary"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span></span></div>
                      </div>
                      <div class="d-flex flex-column w-100 mr-3">
                        <div class="card card-body ml-3 p-0 d-flex w-100">
                          <table class="mb-2">
                            <thead>
                              <tr>
                                <th class="col-11">
                                  Escopo - não listado nos itens do programa
                                </th>

                                <th class="col-5 pl-0"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="col-11">
                                  <strong
                                    class="wb-bw fs-16"
                                    v-text="reportData.alternativeScope"
                                  ></strong>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- item impact -->
                  <div v-if="reportData.impact" class="align-self-start w-100">
                    <div class="d-flex align-self-start v-line">
                      <span class="pb-4"></span>
                    </div>

                    <div class="d-flex align-self-start h-profile-circle">
                      <div class="circle d-flex justify-content-center">
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-primary"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span></span></div>
                      </div>
                      <div class="d-flex flex-column w-100 mr-3">
                        <div class="card card-body ml-3 p-0 d-flex w-100">
                          <table class="mb-2">
                            <thead>
                              <tr>
                                <th class="col-24" v-text="$ml.get('impact')">
                                  Impacto
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="col-24 standard-p">
                                  <p v-text="reportData.impact"></p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Item Description -->
                  <div class="align-self-start w-100">
                    <div class="d-flex align-self-start v-line">
                      <span class="pb-4"></span>
                    </div>

                    <div class="d-flex align-self-start h-profile-circle">
                      <div class="circle d-flex justify-content-center">
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-primary"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span></span></div>
                      </div>
                      <div class="d-flex flex-column w-100 mr-3">
                        <div class="card card-body ml-3 p-0 d-flex w-100">
                          <table class="mb-2">
                            <thead>
                              <tr class="">
                                <th
                                  class="col-24 position-relative"
                                  v-text="$ml.get('waysExplore')"
                                >
                                  Formas de Explorar
                                </th>
                                <svg
                                  v-if="
                                    $utils.convertMarkedOld(
                                      decodeBase64(reportData.description),
                                    ) !=
                                    $utils.convertMarkedOld(
                                      decodeBase64(
                                        reportData.translated_description,
                                      ),
                                    )
                                  "
                                  v-b-tooltip.hover
                                  :title="$ml.get('seeOriginalText')"
                                  @click="
                                    showOriginalContract = !showOriginalContract
                                  "
                                  width="25"
                                  height="25"
                                  class="mx-2 icon-contract"
                                >
                                  <image
                                    xlink:href="../../../src/assets/svg/aa.svg"
                                    width="25"
                                    height="25"
                                  />
                                </svg>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="col-24" @click="linkExternal">
                                  <div
                                    class="border-0 p-3 comment-img text-markdown"
                                    v-if="
                                      compareDate(reportData.createdAt) ||
                                      reportData.newReport
                                    "
                                    v-html="
                                      $utils.convertMarkedOld(
                                        reportData.encoded_base64
                                          ? decodeBase64(
                                              showOriginalContract
                                                ? reportData.description
                                                : reportData.translated_description,
                                            )
                                          : compareDateTab(
                                              reportData.createdAt,
                                              showOriginalContract
                                                ? reportData.description
                                                : reportData.translated_description,
                                            ),
                                        reportData.files,
                                      )
                                    "
                                  ></div>

                                  <div
                                    class="border-0 p-3 comment-img text-markdown"
                                    v-else
                                    v-html="
                                      $utils.convertHtml(
                                        showOriginalContract
                                          ? reportData.description
                                          : reportData.translated_description,
                                      )
                                    "
                                  ></div>
                                  <div v-if="reportData.files" class="mt-4">
                                    <a
                                      v-for="(item, index) in reportData.files"
                                      :key="index"
                                      :href="item.path"
                                      target="new_blank"
                                      rel="noopener noreferrer"
                                      class="p-2 my-2 rounded link-download d-flex flex-row justify-content-between"
                                      style="color: rgba(136, 136, 136, 0.68)"
                                    >
                                      <span>
                                        <strong>{{ item.id }}</strong
                                        >:
                                        <span
                                          v-text="
                                            item.name.substring(0, 40) +
                                            (item.name.length > 40
                                              ? '... '
                                              : '')
                                          "
                                        ></span>
                                        {{ item.size }}
                                      </span>
                                      <svg width="16" height="16" class="mt-1">
                                        <image
                                          xlink:href="../../../src/assets/icons/download.svg"
                                          width="16"
                                          height="16"
                                        />
                                      </svg>
                                    </a>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Items Events -->
                  <div
                    class="align-self-start w-100"
                    v-for="(item, index) in events"
                    :key="index"
                  >
                    <div class="d-flex align-self-start v-line">
                      <span class="pb-5"></span>
                    </div>

                    <div class="d-flex align-self-start h-profile-circle">
                      <div class="circle d-flex justify-content-center">
                        <span
                          class="circle-internal d-flex justify-content-center"
                        >
                          <span
                            v-if="item.action == 'pay_bounty'"
                            class="circle-pending"
                          ></span>
                          <span v-else class="circle-primary"></span>
                        </span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span></span></div>
                      </div>
                      <div class="d-flex flex-column limit-container">
                        <div class="pl-3 d-flex align-items-center mb-3">
                          <div
                            class="d-flex flex-row justify-content-between align-items-start w-100"
                          >
                            <p class="align-items-center row rowAction">
                              <a
                                class="mr-1"
                                v-if="item.author_type == 'company'"
                                v-text="
                                  item.deleted_author
                                    ? $store.getters['getCompany']
                                    : item.author
                                "
                              >
                              </a>

                              <a
                                class="mr-1"
                                v-else
                                v-text="
                                  item.deleted_author
                                    ? $ml.get('userRemoved')
                                    : item.author
                                "
                              ></a>

                              <font v-if="item.action == 'move_to_locker'">
                                <font>{{ $ml.get("reportMovedToVault") }}</font>
                              </font>

                              <font v-if="item.action == 'move_out_of_locker'">
                                <font>{{
                                  $ml.get("reportMovedOutOfVault")
                                }}</font>
                              </font>

                              <font v-if="item.action == 'comment'">
                                <font v-text="$ml.get('postedComment')"
                                  >postou um comentário</font
                                >
                                <font v-if="item.visibility != 'public'"
                                  >&nbsp;
                                  <font v-text="$ml.get('like')"> do tipo </font
                                  >&nbsp;
                                  {{ $ml.get(item.visibility) }}
                                </font>
                              </font>

                              <font v-if="item.action == 'request_review'">
                                <font v-text="$ml.get('request_review_report')"
                                  >solicitou revisão da triagem</font
                                >&nbsp;
                                <a>{{ $ml.get(item.new_value) }}</a>
                              </font>

                              <font v-if="item.action == 'close_report'">
                                <font v-text="$ml.get('closedTheReportAs')"
                                  >fechou o relatório como</font
                                >&nbsp;
                                <a>{{ $ml.get(item.new_value) }}</a>
                              </font>

                              <font v-if="item.action == 'reopen_report'">
                                <font v-text="$ml.get('reopenedTheReport')"
                                  >reabriu o relatório</font
                                >
                              </font>

                              <font v-if="item.action == 'change_situation'">
                                <font
                                  v-if="item.old_value"
                                  v-text="
                                    messageMl('changedTheStatusFrom', item)
                                  "
                                  >alterou a situação de * para *</font
                                >
                                <font
                                  v-else
                                  v-text="
                                    messageMl('changedTheSituationTo', item)
                                  "
                                  >alterou a situação para *</font
                                >
                              </font>

                              <font v-if="item.action == 'update_visibility'">
                                <font
                                  v-if="item.old_value"
                                  v-text="
                                    messageMl('changedTheVisibilityOf', item)
                                  "
                                  >alterou a visibilidade de * para *</font
                                >
                                <font
                                  v-else
                                  v-text="
                                    messageMl('changedTheVisibilityTo', item)
                                  "
                                  >alterou a visibilidade para *</font
                                >
                              </font>

                              <font v-if="item.action == 'update_title'">
                                <font
                                  v-if="item.old_value"
                                  v-text="messageMl('changedTheTitleOf', item)"
                                  >alterou o título do relatório de * para
                                  *</font
                                >
                                <font
                                  v-else
                                  v-text="messageMl('changedTheTitleTo', item)"
                                  >alterou o título do relatório para *</font
                                >
                              </font>

                              <font v-if="item.action == 'retest'">
                                {{ $ml.get("requestedANewTestOfTheReport") }}
                              </font>

                              <font v-if="item.action == 'evaluate_retest'">
                                {{
                                  item.new_value == "approved"
                                    ? $ml.get("approvedRetest")
                                    : $ml.get("refusedRetest")
                                }}
                              </font>

                              <font v-if="item.action == 'submit_retest'">
                                {{
                                  item.new_value == "confirmed"
                                    ? $ml.get(
                                        "reportedThatTheVulnerabilityIsFixed",
                                      )
                                    : $ml.get(
                                        "reportedThatTheVulnerabilityIsNotPatched",
                                      )
                                }}
                              </font>

                              <font
                                v-if="item.action == 'update_severity'"
                                class="d-flex align-items-center"
                              >
                                <font
                                  v-if="item.old_value"
                                  class="row align-items-center"
                                >
                                  <font
                                    v-text="$ml.get('adjustedTheImpactFrom')"
                                    >ajustou o impacto de * para *</font
                                  >
                                  <img
                                    src="../../../src/assets/icons/long-arrow-right.svg"
                                    class="ico-15 mx-1 mt-1"
                                  />
                                  <Impact
                                    class="mt-1 mr-1"
                                    :impact="'impact-' + item.old_value"
                                  />
                                  <font v-text="$ml.get('to')"></font>
                                  <img
                                    src="../../../src/assets/icons/long-arrow-right.svg"
                                    class="ico-15 mx-1 mt-1"
                                  />
                                  <Impact
                                    class="mt-1 mr-1"
                                    :impact="'impact-' + item.new_value"
                                  />
                                </font>

                                <font v-else class="row align-items-center">
                                  <font v-text="$ml.get('adjustedTheImpactTo')"
                                    >ajustou o impacto para
                                  </font>
                                  <img
                                    src="../../../src/assets/icons/long-arrow-right.svg"
                                    class="ico-15 mx-1 mt-1"
                                  />
                                  <Impact
                                    class="mt-1 mr-1"
                                    :impact="'impact-' + item.new_value"
                                  />
                                </font>
                              </font>

                              <font
                                v-if="item.action == 'pay_bounty'"
                                class="d-flex align-items-center"
                              >
                                <font>
                                  <font v-text="$ml.get('requestedPaymentOf')"
                                    >solicitou o pagamento de</font
                                  >&nbsp;
                                  <div class="area-btn">
                                    <a
                                      style="white-space: nowrap"
                                      v-if="currency == 'BRL'"
                                      >{{
                                        $utils.convertMoney(item.new_value)
                                      }}</a
                                    >
                                    <a
                                      style="white-space: nowrap"
                                      v-if="currency == 'USDT'"
                                      >{{
                                        $utils.convertDollar(item.new_value)
                                      }}</a
                                    >
                                    <b-button
                                      v-b-toggle.collapse-1
                                      @click="
                                        togglePaymentStatus =
                                          !togglePaymentStatus
                                      "
                                      class="detail-icon-button bg-light"
                                    >
                                      <span class="ico-btn">
                                        <img
                                          v-if="togglePaymentStatus"
                                          class="img-ico-btn ml-2"
                                          src="../../../src/assets/icons/eye-slash.svg"
                                        />
                                        <img
                                          v-if="!togglePaymentStatus"
                                          class="img-ico-btn ml-2"
                                          src="../../../src/assets/icons/eye.svg"
                                        />
                                      </span>
                                    </b-button>
                                  </div>
                                </font>
                              </font>
                              <font v-if="item.action == 'pay_retest'">
                                {{ $ml.get("requestedRetestPayment") }}
                              </font>

                              <font v-if="item.action == 'request_update'">
                                {{
                                  item.new_value == "closure"
                                    ? $ml.get("reportClosureRequest")
                                    : $ml.get("responseRequestReport")
                                }}
                              </font>

                              <font v-if="item.action == 'update_score'">
                                <span>
                                  {{ $ml.get("conceded") }}
                                  {{ item.score }}
                                  {{ $ml.get("points").toLowerCase() }}
                                  {{ $ml.get("toTheSpecialist") }}
                                  {{
                                    reportData.deleted_author
                                      ? $ml.get("userRemoved")
                                      : reportData.hacker_username
                                  }}
                                </span>
                              </font>
                            </p>
                            <p class="time">
                              {{ $utils.formatDataLong(item.createdAt) }}
                            </p>
                          </div>
                        </div>
                        <b-collapse
                          v-if="item.action == 'pay_bounty'"
                          id="collapse-1"
                          class="mt-2"
                        >
                          <payRequestCard
                            :payment_status="payment_status"
                            :hacker_username="hacker_username"
                            :currency="currency"
                          />
                        </b-collapse>

                        <p
                          class="pl-3 mb-3"
                          style="margin-top: -15px"
                          v-if="
                            item.action == 'retest' && reportData.retest_payment
                          "
                        >
                          <font>
                            <font
                              class="row"
                              v-html="
                                $ml
                                  .with(
                                    reportData.retest_hacker_percentage + '%',
                                  )
                                  .get('paidRetest')
                              "
                            >
                            </font>
                            <font
                              v-if="reportData.retest_max_time >= 0"
                              class="row pt-1"
                            >
                              {{
                                $ml
                                  .with(reportData.retest_max_time)
                                  .get("theRetestMustBeSentWithinDays")
                              }}.
                            </font>
                            <font class="row pt-1">
                              {{ $ml.get("retestId") }}:&nbsp;{{ item._id }}
                            </font>
                          </font>
                        </p>

                        <p
                          class="pl-3 mb-3"
                          style="margin-top: -15px"
                          v-if="item.action == 'pay_retest'"
                        >
                          <font>
                            <font class="row">
                              <b>{{ $ml.get("retestId") }}:</b>&nbsp;{{
                                item.retestId
                              }}
                            </font>
                            <font v-if="currency === 'BRL'" class="row pt-1">
                              <b>{{ $ml.get("value") }}:</b>&nbsp;{{
                                $utils.convertMoney(item.old_value)
                              }}
                            </font>
                            <font v-else class="row pt-1">
                              <b>{{ $ml.get("value") }}:</b>&nbsp;{{
                                $utils.convertDollar(item.old_value)
                              }}
                            </font>
                          </font>
                        </p>

                        <p
                          class="pl-3 mb-3"
                          style="margin-top: -15px"
                          v-if="item.action == 'close_report'"
                        >
                          <font
                            v-if="item.duplicated.title"
                            class="row pt-1 mb-0"
                          >
                            <font>
                              <font v-text="$ml.get('inRelationToTheReport')"
                                >Referente ao relatório</font
                              >: <a>{{ item.duplicated.title }}</a>
                            </font>
                          </font>
                          <font v-if="item.duplicated.title" class="row mb-0">
                            <font>
                              <font v-text="$ml.get('published')"
                                >Publicado</font
                              >:
                              <a
                                v-text="
                                  $ml
                                    .with(
                                      $utils.formatData(
                                        item.duplicated.sent_at,
                                        $ml.get('ln'),
                                      ),
                                    )
                                    .get('ago')
                                "
                              ></a>
                            </font>
                          </font>
                          <font v-if="item.duplicated.title" class="row mb-0">
                            <font
                              >Status:
                              <a v-text="$ml.get(item.duplicated.status)"></a>
                            </font>
                          </font>
                        </p>

                        <div
                          v-if="item.message"
                          class="card ml-3 text-markdown"
                        >
                          <div class="card-body ml-3">
                            <div class="flex-row mr-3" @click="linkExternal">
                              <svg
                                v-if="
                                  $utils.convertMarkedOld(
                                    decodeBase64(item.message),
                                  ) !=
                                  $utils.convertMarkedOld(
                                    decodeBase64(item.translated_message),
                                  )
                                "
                                v-b-tooltip.hover
                                :title="
                                  showOriginalComment
                                    ? $ml.get('translateText')
                                    : $ml.get('seeOriginalText')
                                "
                                @click="
                                  showOriginalComment = !showOriginalComment
                                "
                                width="25"
                                height="25"
                                class="mx-2 icon-comment"
                              >
                                <image
                                  xlink:href="../../../src/assets/svg/aa.svg"
                                  width="25"
                                  height="25"
                                />
                              </svg>
                              <div
                                v-if="
                                  (compareDate(item.createdAt) ||
                                    item.newComment ||
                                    compareDateComment(item.createdAt)) &&
                                  !item.show_original_comment
                                "
                                class="border-0 p-0"
                                v-html="
                                  $utils.convertMarkedOld(
                                    item.encoded_base64
                                      ? decodeBase64(item.translated_message)
                                      : item.translated_message,
                                    item.files,
                                  )
                                "
                              ></div>
                              <!-- <div
                                v-else
                                class="border-0 p-0 comment-img h-100"
                                v-html="
                                  $utils.convertHtml(
                                    showOriginalComment
                                      ? item.message
                                      : item.translated_message
                                  )
                                "
                              ></div> -->
                              <div
                                v-if="
                                  (compareDate(item.createdAt) ||
                                    item.newComment ||
                                    compareDateComment(item.createdAt)) &&
                                  item.show_original_comment
                                "
                                class="border-0 p-0"
                                v-html="
                                  $utils.convertMarkedOld(
                                    item.encoded_base64
                                      ? decodeBase64(item.message)
                                      : item.message,
                                    item.files,
                                  )
                                "
                              ></div>
                            </div>
                          </div>
                          <div v-if="item.files" class="p-3">
                            <a
                              v-for="(item, index) in item.files"
                              :key="index"
                              :href="item.path"
                              target="new_blank"
                              rel="noopener noreferrer"
                              class="p-2 my-1 rounded link-download d-flex flex-row justify-content-between"
                              style="color: rgba(136, 136, 136, 0.68)"
                            >
                              <span>
                                <strong>{{ item.id }}</strong
                                >:
                                <span
                                  v-text="
                                    item.name.substring(0, 40) +
                                    (item.name.length > 40 ? '... ' : '')
                                  "
                                ></span>
                                {{ item.size }}
                              </span>
                              <svg width="16" height="16" class="mt-1">
                                <image
                                  xlink:href="../../../src/assets/icons/download.svg"
                                  width="16"
                                  height="16"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="permission" class="card mb-3 p-3">
                  <div class="card-header pb-3">
                    <div class="d-flex flex-row">
                      <svg width="16" height="16" class="mr-2">
                        <image
                          xlink:href="../../../src/assets/icons/cog.svg"
                          width="16"
                          height="16"
                        />
                      </svg>
                      <div
                        v-text="$ml.get('theActionsTakenOnTheReportCannotBe')"
                      >
                        As ações feitas no relatório não poderão ser removidas!
                      </div>
                    </div>
                  </div>

                  <div
                    class="card-body footer-helper pb-0 d-flex flex-column justify-content-left"
                  >
                    <form
                      v-if="
                        $store.getters['getUserType'] == 'company' ||
                        $store.getters['getUserType'] == 'hacker'
                      "
                    >
                      <div class="row">
                        <div class="col-9">
                          <div class="form-group">
                            <div class="form-group">
                              <multiselect
                                v-if="
                                  $store.getters['getUserType'] == 'company'
                                "
                                v-model="actionSelected"
                                label=""
                                :custom-label="
                                  (name) => `${nameLang({ name })}`
                                "
                                :options="
                                  itensAction.filter(
                                    (item) => item != 'request_update',
                                  )
                                "
                                :searchable="false"
                                :close-on-select="true"
                                :show-labels="false"
                                :allow-empty="false"
                                @input="alterItens"
                                :preselect-first="true"
                                :placeholder="$ml.get('select')"
                              >
                              </multiselect>

                              <!-- usuário especialista -->
                              <multiselect
                                v-if="$store.getters['getUserType'] == 'hacker'"
                                v-model="actionSelected"
                                label=""
                                :custom-label="
                                  (name) => `${nameLang({ name })}`
                                "
                                :options="
                                  tenDaysAfterReportCreation
                                    ? itensAction.filter(
                                        (item) =>
                                          item == 'request_update' ||
                                          item == 'comment',
                                      )
                                    : itensAction.filter(
                                        (item) =>
                                          item == 'comment' ||
                                          item == 'request_review',
                                      )
                                "
                                :searchable="false"
                                :close-on-select="true"
                                :show-labels="false"
                                :allow-empty="false"
                                @input="alterItens"
                                :preselect-first="true"
                                :placeholder="$ml.get('select')"
                              >
                              </multiselect>
                            </div>
                          </div>
                        </div>

                        <div
                          v-if="
                            (actionSelected != 'comment' &&
                              actionSelected != 'request_review') ||
                            $store.getters['getUserType'] != 'hacker'
                          "
                          class="col-2 d-flex align-items-center justify-content-center"
                          style="height: 36px"
                        >
                          <img
                            v-if="
                              actionSelected != 'retest' &&
                              actionSelected != 'reopen_report' &&
                              actionSelected != 'move_to_locker' &&
                              actionSelected != 'move_out_of_locker'
                            "
                            src="../../../src/assets/icons/arrow-right.svg"
                            class="ico-18"
                          />
                        </div>

                        <div
                          v-if="
                            actionSelected != 'pay_bounty' &&
                            actionSelected != 'retest' &&
                            actionSelected != 'reopen_report' &&
                            actionSelected != 'move_to_locker' &&
                            actionSelected != 'move_out_of_locker'
                          "
                          class="col-8"
                        >
                          <div
                            v-if="
                              (actionSelected != 'comment' &&
                                actionSelected != 'request_review') ||
                              $store.getters['getUserType'] != 'hacker'
                            "
                            class="form-group"
                          >
                            <multiselect
                              v-model="itemSelected"
                              :options="itensSelect"
                              :searchable="false"
                              label="name"
                              :custom-label="nameLang"
                              :close-on-select="true"
                              :show-labels="false"
                              :allow-empty="false"
                              :preselect-first="true"
                              :multiple="false"
                              :placeholder="$ml.get('select')"
                            >
                            </multiselect>
                          </div>
                        </div>

                        <div
                          v-else-if="actionSelected == 'pay_bounty'"
                          class="col-8"
                        >
                          <div class="form-group" style="position: relative">
                            <label
                              v-if="currency === 'BRL'"
                              class="currency real"
                              >R$</label
                            >
                            <label v-else class="currency">US$</label>
                            <money
                              class="form-control mask-real"
                              @input.native="mathAbsMoney"
                              v-model.number="itemSelected.id"
                              :placeholder="placeholderMoney"
                              maxLength="20"
                            />
                            <transition
                              name="fade"
                              v-if="
                                itemSelected.id >= sugested_bounty &&
                                active_campaign &&
                                double_bounty &&
                                !errorPayBounty
                              "
                            >
                              <label
                                class="lblWarning"
                                v-text="$ml.get('doubleReward')"
                              >
                                Recompensa em dobro
                              </label>
                            </transition>
                            <transition
                              name="fade"
                              v-if="
                                itemSelected.id < sugested_bounty &&
                                !errorPayBounty
                              "
                            >
                              <label
                                class="lblError"
                                v-text="$ml.get('suggestedValue')"
                              >
                                O valor deve ser maior ou igual ao valor
                                sugerido.
                              </label>
                            </transition>
                            <transition name="fade">
                              <label
                                v-if="errorPayBounty"
                                class="lblError"
                                v-text="$ml.get('needsValueInformed')"
                                >O valor precisa ser informado!</label
                              >
                            </transition>
                          </div>
                        </div>
                      </div>

                      <div
                        class="row"
                        v-if="
                          actionSelected == 'close_report' &&
                          itemSelected.id == 'duplicated'
                        "
                      >
                        <div class="col-19">
                          <div class="form-group">
                            <label v-text="$ml.get('applicableReport')"
                              >Relatório aplicável</label
                            >
                            <multiselect
                              v-model="reportDuplicateSelected"
                              label="title"
                              :options="listDuplicateReport"
                              :close-on-select="true"
                              :show-labels="false"
                              @search-change="changeReportsDuplicate"
                              :custom-label="nameWithLang"
                              :placeholder="$ml.get('selectTheReport')"
                              :multiple="false"
                              :searchable="true"
                              :allow-empty="false"
                              :preselect-first="false"
                            >
                            </multiselect>
                            <transition name="fade">
                              <label
                                v-if="errorSelectDuplicated"
                                class="lblError mb-2"
                                v-text="$ml.get('theReportNeedsToBeInformed')"
                                >O relatório precisa ser informado</label
                              >
                            </transition>
                          </div>
                        </div>

                        <div class="col-24 mt-2">
                          <label
                            v-b-toggle.more-actions
                            class="text-danger pointer"
                            v-text="$ml.get('moreOptions')"
                            >Mais opções</label
                          >
                        </div>

                        <b-collapse
                          id="more-actions"
                          v-model="btnToggle"
                          class="col-24 pb-3"
                        >
                          <div class="form-group col-9">
                            <multiselect
                              v-model="scopeDuplicateSelected"
                              label="description"
                              :options="listDuplicateEscope"
                              :close-on-select="true"
                              :show-labels="false"
                              :placeholder="$ml.get('selectTheScope')"
                              :multiple="false"
                              :searchable="false"
                              :allow-empty="false"
                              :preselect-first="false"
                            >
                            </multiselect>
                          </div>

                          <div class="form-group col-24 col-md-24">
                            <multiselect
                              v-model="selectedThreat"
                              label="external_id"
                              :options="selectThreat"
                              :close-on-select="true"
                              :show-labels="false"
                              @search-change="changeWeakness"
                              :placeholder="$ml.get('selectTheCWE')"
                            >
                            </multiselect>
                          </div>
                        </b-collapse>
                      </div>
                    </form>

                    <form v-else-if="pending_retest_submission">
                      <div class="row">
                        <div class="col-9">
                          <div class="form-group">
                            <div class="form-group">
                              <multiselect
                                v-model="actionSelected"
                                label=""
                                :custom-label="
                                  (name) => `${nameLang({ name })}`
                                "
                                :options="itensActionHacker"
                                :searchable="false"
                                :close-on-select="true"
                                :show-labels="false"
                                :allow-empty="false"
                                @input="alterItens"
                                :preselect-first="true"
                                :placeholder="$ml.get('select')"
                              >
                              </multiselect>
                            </div>
                          </div>
                        </div>

                        <div
                          class="col-2 d-flex align-items-center justify-content-center"
                          v-if="actionSelected == 'submit_retest'"
                          style="height: 36px"
                        >
                          <img
                            src="../../../src/assets/icons/arrow-right.svg"
                            class="ico-18"
                          />
                        </div>

                        <div
                          class="col-9"
                          v-if="actionSelected == 'submit_retest'"
                        >
                          <div class="form-group">
                            <div class="form-group">
                              <multiselect
                                v-model="retest_status"
                                label=""
                                :custom-label="
                                  (name) =>
                                    `${nameLang({ name: `retest_${name}` })}`
                                "
                                :options="['confirmed', 'denied']"
                                :searchable="false"
                                :close-on-select="true"
                                :show-labels="false"
                                :allow-empty="false"
                                @input="alterItens"
                                :preselect-first="true"
                                :placeholder="$ml.get('select')"
                              >
                              </multiselect>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    <div
                      style="z-index: 0"
                      class="custom-control custom-checkbox"
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        v-model="toggle_text"
                      />
                      <label
                        v-if="messages.length > 0"
                        v-text="$ml.get('clearText')"
                        class="custom-control-label"
                        >Limpar texto</label
                      >
                    </div>
                  </div>
                  <div
                    class="card-body footer-helper pb-0 d-flex flex-column justify-content-left"
                  >
                    <div class="row">
                      <div class="col">
                        <div class="form-group">
                          <svg
                            v-show="!htmlText"
                            @click="viewHtml()"
                            width="24"
                            height="24"
                            class="ico-view-report"
                          >
                            <image
                              xlink:href="../../../src/assets/icons/eye.svg"
                              width="24"
                              height="24"
                            />
                          </svg>
                          <svg
                            v-show="htmlText"
                            @click="htmlText = ''"
                            width="24"
                            height="24"
                            class="ico-view-report"
                          >
                            <image
                              xlink:href="../../../src/assets/icons/eye-slash.svg"
                              width="24"
                              height="24"
                            />
                          </svg>
                          <textarea
                            v-show="!htmlText"
                            id=""
                            class="form-control w-100 text-are-mark"
                            rows="7"
                            v-model="description"
                            @keyup="controlTextArea()"
                            :placeholder="$ml.get('addAcomment') + '...'"
                          >
                          </textarea>

                          <div
                            v-show="htmlText"
                            class="form-control w-100 h-100"
                            v-html="htmlText"
                          ></div>

                          <transition name="fade">
                            <label
                              v-if="error && !$v.description.required"
                              class="lblError"
                              v-text="$ml.get('theCommentNeedsToBeInformed')"
                            ></label>
                            <label
                              v-else-if="descriptionMaxLengt"
                              class="lblError"
                              v-text="
                                $ml
                                  .with('5.000')
                                  .get('maximumLengthIsCharacters')
                              "
                            ></label>
                          </transition>
                        </div>

                        <div
                          v-if="
                            actionSelected == 'comment' ||
                            actionSelected == 'submit_retest'
                          "
                          class="row"
                        >
                          <input
                            type="file"
                            id="files"
                            ref="file"
                            @change="initUpFile($event.target.files)"
                            class="file-upload none"
                            name="files"
                            multiple
                          />
                          <transition>
                            <div
                              class="col p-2 d-flex flex-column input-files"
                              align="center"
                            >
                              <h6 class="mt-2" @click="$refs.file.click()">
                                <font
                                  class="p-2"
                                  v-text="$ml.get('uploadFiles')"
                                  >Enviar arquivos</font
                                >
                                <svg width="20" height="20">
                                  <image
                                    xlink:href="../../../src/assets/icons/paperclip.svg"
                                    width="20"
                                    height="20"
                                  />
                                </svg>
                              </h6>
                              <p
                                v-for="(item, index) in listFiles"
                                :key="index"
                                class="p-2 my-1 rounded d-flex align-items-center flex-row justify-content-between"
                              >
                                <span>
                                  <input
                                    class="input-none"
                                    :id="'input' + item.id"
                                    :value="'[' + item.id + ']'"
                                  />
                                  <VueCustomTooltip :label="textTolltip">
                                    <b
                                      @click="copyLink(item.id)"
                                      @mouseout="
                                        textTolltip = this.$ml.get('copyLink')
                                      "
                                      >{{ item.id }}</b
                                    >
                                  </VueCustomTooltip>
                                  :
                                  <span
                                    v-text="
                                      item.originalName.substring(0, 40) +
                                      (item.originalName.length > 40
                                        ? '... '
                                        : '')
                                    "
                                  ></span>
                                  {{ item.sizeFormat }}
                                </span>
                                <svg
                                  @click="removeFile(index)"
                                  width="14"
                                  height="14"
                                >
                                  <image
                                    xlink:href="../../../src/assets/icons/times.svg"
                                    width="14"
                                    height="14"
                                  />
                                </svg>
                              </p>
                            </div>
                          </transition>
                        </div>

                        <transition
                          v-if="
                            actionSelected == 'comment' ||
                            actionSelected == 'submit_retest'
                          "
                          class="row"
                          name="fade"
                        >
                          <label v-if="upload_error" class="lblError">{{
                            upload_error
                          }}</label>
                          <label
                            v-else
                            class="lblError text-primary opacity-25"
                            v-text="$ml.get('allowedFiles')"
                            >Arquivos permitidos: videos e imagens .jpg .jpeg
                            .png
                          </label>
                        </transition>
                      </div>
                    </div>
                  </div>

                  <div class="mt-5">
                    <RecaptchaV2
                      ref="recaptcha"
                      @verify="setRecaptchaToken"
                      @expired="tokenRecaptcha = ''"
                    />
                  </div>

                  <div class="py-3 d-flex align-itens-center">
                    <a
                      v-show="loadingBtn"
                      class="btn btn-primary"
                      style="width: 92px"
                    >
                      <Spinner v-show="true" />
                    </a>
                    <button
                      v-show="!loadingBtn"
                      :disabled="!tokenRecaptcha"
                      @click.once="triggerEvent()"
                      :key="buttonForSaveEvent"
                      class="btn"
                      v-text="$ml.get('save')"
                    >
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Cards lado direito -->
        <div class="col-24 col-md-5 py-3 px-3">
          <section>
            <div class="input-group my-3">
              <input
                class="form-control filterInput"
                autocomplete="off"
                v-model="txtSearch"
                :placeholder="$ml.get('search')"
                aria-label="Search"
                style="border-right: none"
              />
              <div class="input-group-append">
                <div class="input-group-text" style="background-color: #fff">
                  <svg width="20" height="20" class="mt-1">
                    <image
                      xlink:href="../../../src/assets/icons/search_s.svg"
                      width="18"
                      height="18"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="filter_report card card-visitors">
              <div class="card-header card-chart-mini">
                <div class="d-flex flex-row align-items-center">
                  <svg width="16" height="16" class="mr-2">
                    <image
                      xlink:href="../../../src/assets/icons/file-medical-alt.svg"
                      width="16"
                      height="16"
                    />
                  </svg>
                  <span v-text="$ml.get('reports')">Relatórios</span>
                </div>
              </div>
              <div class="card-body px-2">
                <div class="loading d-flex">
                  <div v-if="loadingReport" class="c-loader"></div>
                  <h6
                    v-else
                    v-show="!listReports.length"
                    v-text="$ml.get('noReportsFound')"
                  >
                    Nenhum relatório encontrado
                  </h6>
                </div>

                <div
                  class="d-column flex-row"
                  v-for="(item, index) in listReports"
                  :key="index"
                >
                  <div
                    :class="
                      'pointer pt-2 ' +
                      (item.report_id == reportData._id ? 'selected' : '')
                    "
                    @click="changeReportByCard(item.report_id)"
                  >
                    <div
                      :class="
                        'h-profile pb-3 align-items-center ' +
                        (index == listReports.length - 1 ? 'no' : '')
                      "
                    >
                      <div class="d-flex align-self-start">
                        <div class="mx-1" style="min-width: 50px !important">
                          <div
                            v-if="$store.getters['getUserType'] == 'company'"
                            class="position-relative d-flex align-items-center mr-1"
                          >
                            <object
                              width="42"
                              height="42"
                              class="rounded-circle img-m"
                              :data="item.person_avatar"
                              type="image/png"
                            >
                              <img
                                width="42"
                                height="42"
                                class="rounded-circle img-m"
                                src="../../assets/images/default.png"
                                alt="Avatar"
                              />
                            </object>

                            <div v-show="item.hacker_verified" class="verify">
                              <img
                                src="../../../src/assets/icons/badge-check.png"
                                width="16"
                                height="16"
                              />
                            </div>
                          </div>

                          <object
                            v-else
                            width="42"
                            height="42"
                            class="rounded-circle img-m"
                            :data="item.program_avatar"
                            type="image/png"
                          >
                            <img
                              width="42"
                              height="42"
                              class="rounded-circle img-m"
                              src="../../assets/images/default.png"
                              alt="Avatar"
                            />
                          </object>

                          <div
                            id="severity-icon-report"
                            class="d-flex mt-2 justify-content-start align-items-center"
                          >
                            <Impact
                              :impact="'impact-' + item.report_severity"
                            />
                          </div>
                        </div>

                        <div class="d-flex w-100 align-items-start flex-column">
                          <div
                            class="d-flex align-items-center justify-content-between col"
                          >
                            <b class="align-self-center"
                              ><a v-text="item.report_title"></a
                            ></b>
                            <span
                              v-if="item.locker"
                              class="ico mx-2 border ico-vault"
                            >
                              <img
                                src="../../../src/assets/icons/vault.png"
                                class="ico-20"
                              />
                            </span>
                          </div>
                          <div
                            v-if="$store.getters['getUserType'] == 'company'"
                            class="d-flex flex-row justify-content-between align-items-start w-100"
                          >
                            <p>
                              <font>Especialista</font>:&ensp;<a
                                class="mb-2"
                                v-text="item.hacker_username"
                              >
                              </a>
                            </p>
                          </div>

                          <div
                            class="d-flex flex-row justify-content-between align-items-start w-100"
                          >
                            <p>
                              <font v-text="$ml.get('program')">Programa</font
                              >:&ensp;<a
                                class="mb-2"
                                v-text="item.program_name"
                              ></a
                              ><br />
                            </p>
                          </div>

                          <div
                            class="d-flex flex-row justify-content-between align-items-start w-100"
                          >
                            <p>
                              <font>
                                <font v-text="$ml.get('situation')"></font>:
                                <a
                                  class="text-capitalize"
                                  v-text="$ml.get(item.report_situation)"
                                ></a>
                              </font>
                            </p>
                          </div>

                          <div
                            class="d-flex flex-row justify-content-between align-items-start w-100"
                          >
                            <p>
                              Status:
                              <a
                                class="mb-2"
                                v-text="$ml.get(item.report_status)"
                              ></a>
                            </p>
                            <p
                              v-text="
                                $ml
                                  .with(
                                    $utils.formatData(
                                      item.report_createdAt,
                                      $ml.get('ln'),
                                    ),
                                  )
                                  .get('ago')
                              "
                            >
                              há
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <!-- Modal link -->
        <b-modal
          id="modal-link"
          class="my-modal"
          data-bs-keyboard="false"
          hide-header
          size="ml"
          footer-bg-variant="light"
          @hidden="resetLink"
        >
          <b-container fluid="lg">
            <div class="col modal-body">
              <h4 class="m-0">{{ $ml.get("externalLinkNotice") }}</h4>
            </div>
          </b-container>

          <form class="h-100">
            <div class="col p-3">
              <p>
                {{ $ml.get("youAreAboutToVisitLink") }}
              </p>
              <p>
                {{ $ml.get("proofOfConceptLinks") }}
              </p>
              <p class="my-0">
                {{ $ml.get("youShouldConsiderUsingSeparate") }}
              </p>
            </div>
            <pre class="mx-3 py-0 d-flex justify-content-start"> 
              <code class="p-2" v-text="linkTarget">  
              </code>
            </pre>
          </form>

          <template #modal-footer>
            <div class="w-100 float px-3">
              <b-button
                variant="primary"
                size="sm"
                class="float-right btn-outline-extra"
                v-text="$ml.get('cancel')"
                @click="$bvModal.hide('modal-link')"
              >
              </b-button>
              <a
                class="float-right mr-3"
                target="_blank"
                rel="noopener noreferrer"
                :href="linkTarget"
                @click="$bvModal.hide('modal-link')"
              >
                <b-button
                  variant="primary"
                  size="sm"
                  v-text="$ml.get('continue')"
                >
                </b-button>
              </a>
            </div>
          </template>
        </b-modal>

        <!-- Modal Tags -->
        <b-modal
          id="modal-tags"
          class="my-modal"
          data-bs-keyboard="false"
          hide-header
          size="ml"
          footer-bg-variant="light"
        >
          <b-container fluid="lg">
            <div class="col modal-body">
              <h4 class="m-0">{{ $ml.get("reportTags") }}</h4>
            </div>
          </b-container>

          <div>
            <div v-if="!optionsTags.length">
              <h6
                class="m-3"
                v-html="$ml.get('youDoNotHaveAnyTagRegistered')"
              ></h6>
            </div>
            <form v-else v-on:submit.prevent="">
              <div class="row mb-3 mx-3">
                <b-form-checkbox-group
                  class="checkTags d-block"
                  v-model="selectedTags"
                  name="button"
                  buttons
                >
                  <b-form-checkbox
                    v-for="(tag, index) in optionsTags"
                    :key="index"
                    :value="tag"
                  >
                    <span>{{ $utils.capitalizeFirstLetter(tag) }}</span>
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </div>
            </form>
          </div>

          <template #modal-footer>
            <div class="w-100 float px-3">
              <b-button
                variant="primary"
                size="sm"
                class="float-right btn-outline-extra"
                v-text="$ml.get('cancel')"
                @click="$bvModal.hide('modal-tags')"
              >
              </b-button>

              <a
                v-show="loadingBtn"
                class="btn btn-primary float-right mr-3"
                style="width: 92px"
              >
                <Spinner v-show="true" />
              </a>

              <b-button
                v-show="!loadingBtn"
                class="float-right mr-3"
                variant="primary"
                size="sm"
                v-text="$ml.get('save')"
                @click="alterTag()"
              >
              </b-button>
            </div>
          </template>
        </b-modal>

        <!-- Hacker analysis-->
        <b-modal
          id="modal-analysis"
          class="modal-analysis pl-3"
          data-bs-keyboard="false"
          hide-header
          footer-bg-variant="light"
          @hidden="resetLink"
          data-bs-backdrop="static"
          aria-hidden="true"
        >
          <b-container fluid="lg">
            <div class="col modal-body">
              <h4 class="m-0">{{ $ml.get("reportEvaluation") }}</h4>
            </div>
          </b-container>

          <div class="d-flex flex-column">
            <p class="mb-3 px-3">{{ $ml.get("thisIsAnInternalSurvey") }}</p>

            <div class="row px-3 mb-2">
              <div class="col">
                <h6
                  class="py-2 mb-0"
                  v-text="$ml.get('selectAScoreForTheReport')"
                ></h6>

                <div>
                  <b-form-radio-group
                    v-model="writing_evaluation"
                    :options="selectEvaluation"
                    class="mb-3"
                    value-field="item"
                    text-field="name"
                    disabled-field="notEnabled"
                  ></b-form-radio-group>
                </div>
              </div>
            </div>

            <div class="row px-3 mb-2" v-if="target_settings?.active">
              <div class="col">
                <h6
                  class="py-2 mb-0"
                  v-text="$ml.get('achievedTheObjective')"
                ></h6>
                <div>
                  <b-form-group>
                    <b-form-radio
                      v-model="target_selected"
                      name="some-radios"
                      :value="true"
                      >Sim</b-form-radio
                    >
                    <b-form-radio
                      v-model="target_selected"
                      name="some-radios"
                      :value="false"
                      >Não</b-form-radio
                    >
                  </b-form-group>
                </div>
              </div>
            </div>

            <div class="row px-3 mb-2">
              <div class="col">
                <h6
                  class="py-2 mb-0"
                  v-text="$ml.get('whatTypeOfVulnerability')"
                ></h6>
                <multiselect
                  v-model="scope_type"
                  label=""
                  :custom-label="nameLangScope"
                  :options="selectScopeType"
                  :searchable="false"
                  :close-on-select="true"
                  :show-labels="false"
                  :allow-empty="false"
                  :placeholder="$ml.get('select')"
                >
                </multiselect>
              </div>
            </div>

            <div
              v-if="this.programActiveHof && !this.isHackerOnHof"
              class="row px-3 mb-2 mt-3"
            >
              <div class="col d-flex flex align-items-center">
                <label class="switch mb-0 mr-2">
                  <input type="checkbox" v-model="addHackerToHof" />
                  <span class="slider round"></span>
                </label>
                <h6 class="py-2 mb-0" v-text="$ml.get('addHackerToHof')"></h6>
              </div>
            </div>
            <div class="mt-3 d-flex justify-content-center">
              <RecaptchaV2
                ref="recaptcha"
                @verify="setRecaptchaToken($event, 'modal')"
                @expired="tokenRecaptchaModal = ''"
              />
            </div>
          </div>

          <template #modal-footer>
            <div class="w-100 float px-3">
              <a
                v-if="loadingBtn"
                class="btn btn-primary float-right"
                style="width: 92px"
              >
                <Spinner v-show="true" />
              </a>
              <b-button
                v-else
                style="border: none"
                :disabled="!tokenRecaptchaModal || !scope_type"
                class="float-right"
                variant="primary"
                size="sm"
                @click="saveEventReport()"
                v-text="$ml.get('save')"
              >
              </b-button>
            </div>
          </template>
        </b-modal>

        <!-- Modal password pdf-->
        <b-modal
          id="modal-password"
          class="modal-analysis pl-3"
          data-bs-keyboard="false"
          hide-header
          footer-bg-variant="light"
          @hidden="resetLink"
          data-bs-backdrop="static"
          aria-hidden="true"
        >
          <div class="p-2">
            <b-container fluid="lg">
              <div class="d-flex align-items-center mb-3" style="gap: 10px">
                <div class="icon-header">
                  <img src="../../../src/assets/icons/doc-pdf.svg" width="22" />
                </div>
                <div>
                  <h4
                    class="mb-0"
                    style="font-size: 16px"
                    v-text="$ml.get('lblExportReport')"
                  >
                    Exportar Relatório
                  </h4>
                  <p
                    class="mb-0"
                    style="font-size: 14px"
                    v-text="$ml.get('descExportReport')"
                  >
                    Arquivo protegido por senha
                  </p>
                </div>
              </div>
            </b-container>

            <div class="d-flex flex-column">
              <div class="info-modal-pdf mb-3">
                <div class="">
                  <img
                    src="../../assets/icons/shield-info-icon.svg"
                    alt="icon"
                    width="20"
                  />
                </div>
                <p class="mb-1" v-text="$ml.get('lblPdfInfo')">
                  Para sua segurança, o PDF será protegido com a senha que você
                  definir abaixo.
                </p>
              </div>
              <div>
                <div class="d-flex align-items-center mb-1">
                  <div>
                    <img
                      src="../../assets/icons/lock-pdf.svg"
                      alt="icon"
                      width="20"
                    />
                  </div>
                  <p
                    class="mb-0 ml-1"
                    style="font-size: 15px; font-weight: 400"
                    v-text="$ml.get('lblPasswordPdf')"
                  >
                    Definir uma senha para o PDF
                  </p>
                </div>
                <div style="display: flex; position: relative" class="mb-3">
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    class="form-control"
                    v-model="passwordPdf"
                    name="password"
                    :placeholder="$ml.get('passwordDownloadPdf')"
                    maxlength="200"
                  />
                  <VueCustomTooltip
                    :label="
                      $ml.get(showPassword ? 'unshowPassword' : 'showPassword')
                    "
                    class="login-ico"
                    style="position: absolute"
                  >
                    <svg class="ico-20" @click="showPassword = !showPassword">
                      <image
                        v-show="showPassword"
                        xlink:href="../../assets/icons/eye-slash.svg"
                        width="20"
                        height="20"
                      />
                      <image
                        v-show="!showPassword"
                        xlink:href="../../assets/icons/eye.svg"
                        width="20"
                        height="20"
                      />
                    </svg>
                  </VueCustomTooltip>
                </div>
              </div>
              <div class="box-check">
                <div class="custom-checkbox px-1">
                  <input
                    type="checkbox"
                    id="checkTerms"
                    v-model="downloadWithEvent"
                    name="check"
                  />
                  <label class="form-check-label label-text" for="checkTerms">
                    <font class="m-4" v-text="$ml.get('lblEventsPdf')"
                      >Incluir conteúdos e eventos</font
                    >
                  </label>
                  <p class="desc-events" v-text="$ml.get('descEventsPdf')">
                    Anexa detalhes completos de atividades e eventos ao
                    relatório
                  </p>
                </div>
              </div>
            </div>
          </div>

          <template #modal-footer>
            <div class="w-100 float px-3">
              <b-button
                :disabled="passwordPdf.length == 0"
                class="float-right"
                variant="primary"
                size="sm"
                @click="generatedPDF()"
              >
                Download
              </b-button>
            </div>
          </template>
        </b-modal>
      </section>
    </main>
  </div>
</template>

<script>
const moment = require("moment");
import $ from "jquery";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import CompanyService from "../../services/company.service";
import ProgramService from "../../services/program.service";
import ReportService from "../../services/report.service";
import RecaptchaV2 from "../recaptchaV2.vue";
import payRequestCard from "../suport/payRequestCard.vue";
import ScoreMultiplierIcon from "../ScoreMultiplierIcon.vue";
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { images } from "../../helpers/mocks";
export default {
  components: {
    RecaptchaV2,
    payRequestCard,
    ScoreMultiplierIcon,
  },
  data() {
    return {
      downloadWithEvent: false,
      currency: "",
      requestedReview: false,
      title: "Details",
      reportData: [],
      programData: [],
      textTolltip: "Copiar link",
      events: [],
      optionsTags: [],
      pendingRetest: true,
      possibleDup: false,
      possibleSpam: false,

      permission: false,

      passwordPdf: "",

      itensAction: [],
      itensActionHacker: ["comment", "submit_retest"],

      retest_status: "confirmed",

      itensComment: [
        // { name: "public", id: "public" },
        { name: "private", id: "private" },
        { name: "internal", id: "internal" },
      ],

      itensSituation: [
        { name: "needs_information", id: "needs_information" },
        { name: "under_review", id: "under_review" },
        { name: "triaged", id: "triaged" },
      ],

      itensSeverity: [
        { name: "critical", id: "critical" },
        { name: "high", id: "high" },
        { name: "medium", id: "medium" },
        { name: "low", id: "low" },
      ],

      itensUpdate: [
        { name: "request_closure", id: "closure" },
        { name: "request_response", id: "response" },
      ],

      itensCloseReport: [
        { name: "approved", id: "approved" },
        { name: "informative", id: "informative" },
        { name: "duplicated", id: "duplicated" },
        { name: "not_applicable", id: "not_applicable" },
        { name: "spam", id: "spam" },
      ],

      itensChangeSituation: [
        { name: "approved", id: "approved" },
        { name: "declined", id: "declined" },
      ],

      listDuplicateReport: [],
      listDuplicateEscope: [],

      reportDuplicateSelected: [],
      scopeDuplicateSelected: [],

      selectedThreat: null,
      selectThreat: [],

      itensSelect: [],
      itemSelected: [],

      actionSelected: "comment",
      options: ["list", "of", "options"],

      htmlText: "",
      tooltipText: "Copiar link",

      description: "",
      descriptionMaxLengt: false,

      listFiles: [],
      listReports: [],

      tagsReport: [],
      tags: [],
      selectedTags: [],

      loadingBtn: false,
      loadingReport: false,
      loading: true,

      errorPayBounty: false,
      errorSelectDuplicated: false,

      upload_error: false,
      error: false,

      txtSearch: "",
      txtSearchDuplicated: " ",
      btnToggle: false,

      linkTarget: "",

      formData: "",

      writing_evaluation: 10,
      scope_type: "",
      selectScopeType: [
        "url",
        "web",
        "api",
        "mobile-application-android",
        "mobile-application-ios",
        "domain",
        "subdomain",
        "ip",
        "other",
      ],
      selectEvaluation: [10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
      yes_no: ["yes", "no"],

      buttonForSaveEvent: 1,

      pending_retest_evaluation: false,
      pending_retest_submission: false,

      cvss: "",
      cvssScore: "",
      reportcreatedAt: "",
      payment_status: [],
      togglePaymentStatus: false,
      hacker_username: "",
      showOriginalContract: false,
      showOriginalSummary: false,
      showOriginalComment: false,
      showOriginalPolicyTarget: false,

      toggle_text: true,
      messages: [],
      optionsSelected: {
        comment: "comment",
        retest: "retest",
        retest_requested: "retest_requested",
        bounty_paid: "bounty_paid",
        pay_bounty: "pay_bounty",
        change_situation: "change_situation",
        needs_information: "needs_information",
        waiting_for_information: "waiting_for_information",
        under_review: "under_review",
        triaged: "triaged",
        close_report: "close_report",
        approved: "approved",
        close_as_approved: "close_as_approved",
        informative: "informative",
        close_as_informative: "close_as_informative",
        duplicated: "duplicated",
        close_as_duplicated: "close_as_duplicated",
        not_applicable: "not_applicable",
        close_as_not_applicable: "close_as_not_applicable",
        spam: "spam",
        close_as_spam: "close_as_spam",
        move_to_locker: "move_to_locker",
        move_out_of_locker: "move_out_of_locker",
      },

      isHackerOnHof: false,
      programActiveHof: false,
      addHackerToHof: false,

      target: null,
      target_settings: [],
      target_selected: true,

      tokenRecaptcha: "",
      oldDescription: "",
      duration: null,
      tokenRecaptchaModal: "",
      active_campaign: false,
      double_bounty: false,
      double_score: false,
      sugested_bounty: 0,
    };
  },
  validations: {
    name: { required },
    description: { required },
  },
  watch: {
    toggle_text() {
      if (!this.toggle_text) {
        this.description = "";
        return;
      }
      return this.generatedText(this.actionSelected);
    },

    actionSelected: function () {
      if (!this.toggle_text) return;
      this.generatedText(this.actionSelected);
    },

    itemSelected: function () {
      if (!this.toggle_text) return;
      this.generatedText(this.actionSelected);

      if (this.actionSelected == "pay_bounty") {
        const bountyBasedOnSeverity =
          this.programData[`bounty_${this.reportData.severity}`];
        console.log(bountyBasedOnSeverity);
        // this.itemSelected.id = Math.abs(bountyBasedOnSeverity);
        this.itemSelected.id = this.sugested_bounty;
      }
    },

    txtSearch: function () {
      this.changeListReport(this.txtSearch);
    },

    scopeDuplicateSelected: function () {
      this.changeReportsDuplicate(" ");
    },

    selectedThreat: function () {
      this.reportDuplicateSelected = [];
      this.changeReportsDuplicate(" ");
    },

    btnToggle: function () {
      this.selectedThreat = [];
      this.scopeDuplicateSelected = [];
      this.changeReportsDuplicate(" ");
    },
  },
  beforeMount() {
    pdfMake.vfs = pdfFonts.pdfMake?.vfs;
  },
  mounted() {
    let { type } = this.$store.getters["getUser"];

    if (type === "company") {
      this.fetchData();
    }
    setTimeout(() => {
      this.generatedText(this.actionSelected);
    }, 1000);

    const locker_id = this.$route.fullPath.split("?")[1].replace("locker", "");
    this.changeReport(locker_id);
    this.changeListReport("");
    this.changeWeakness("a");
    this.changeTags();
    // this.changeLanguage(this.language);

    this.permission =
      ["owner", "administrator", "analyst"].includes(
        this.$store.getters["getUser"].role,
      ) || this.$store.getters["getUserType"] == "hacker";

    this.itensSelect = this.itensComment;
    this.reportData._id = this.$route.fullPath
      .split("?")[1]
      .replace("locker", "");

    if (this.$store.getters["getUserType"] != "hacker") {
      this.changeReportsDuplicate(" ");
    }

    this.itensAction = [
      "comment",
      "change_situation",
      "update_severity",
      "request_update",
      "retest",
      "pay_bounty",
      "close_report",
      "reopen_report",
      "move_to_locker",
      "move_out_of_locker",
    ];
  },

  computed: {
    tenDaysAfterReportCreation() {
      const now = moment();
      let today = moment(now, "DD/MM/YYYY").format("YYYYMMDD");
      let createdAt = moment(this.reportcreatedAt).format("YYYYMMDD");
      let dateTenDaysLater = moment(createdAt, "YYYYMMDD").add(10, "days");

      if (moment(today).isAfter(dateTenDaysLater, "day")) {
        return true;
      }

      return false;
    },
    placeholderMoney() {
      return this.currency === "BRL" ? "R$ 0,00" : "$ 0,00";
    },
  },

  methods: {
    changeReportByCard(reportId) {
      this.changeReport(reportId);
      window.location.reload();
    },

    translateText(item) {
      this.events = this.events.map((it) => {
        if (it._id === item._id) {
          it.show_original_comment = !it.show_original_comment;
        }
        return it;
      });
    },

    decodeBase64(text) {
      try {
        return this.$utils.b64_to_utf8(text);
      } catch {
        return text;
      }
    },

    generatedText(select) {
      var self = this;
      const conditional =
        this.description?.length &&
        this.oldDescription?.length &&
        this.oldDescription.trim() != this.description.trim();
      if (conditional) return;

      if (!this.messages.length) return;

      if (select === this.optionsSelected.change_situation) {
        switch (this.itemSelected.id) {
          case this.optionsSelected.needs_information:
            this.description = this.filterMessage(
              this.messages,
              this.optionsSelected.waiting_for_information,
            );
            break;
          case this.optionsSelected.under_review:
            this.description = this.filterMessage(
              this.messages,
              this.optionsSelected.under_review,
            );
            break;
          case this.optionsSelected.triaged:
            this.description = this.filterMessage(
              this.messages,
              this.optionsSelected.triaged,
            );
            break;
          default:
            this.description = "";
        }
      } else if (select === this.optionsSelected.close_report) {
        switch (this.itemSelected.id) {
          case this.optionsSelected.approved:
            this.description = this.filterMessage(
              this.messages,
              this.optionsSelected.close_as_approved,
            );
            break;
          case this.optionsSelected.informative:
            this.description = this.filterMessage(
              this.messages,
              this.optionsSelected.close_as_informative,
            );
            break;
          case this.optionsSelected.duplicated:
            this.description = this.filterMessage(
              this.messages,
              this.optionsSelected.close_as_duplicated,
            );
            break;
          case this.optionsSelected.not_applicable:
            this.description = this.filterMessage(
              this.messages,
              this.optionsSelected.close_as_not_applicable,
            );
            break;
          case this.optionsSelected.spam:
            this.description = this.filterMessage(
              this.messages,
              this.optionsSelected.close_as_spam,
            );
            break;
          default:
            this.description = "";
        }
      } else {
        switch (select) {
          case this.optionsSelected.comment:
            this.description = this.filterMessage(
              this.messages,
              this.optionsSelected.comment,
            );
            break;
          case this.optionsSelected.retest:
            this.description = this.filterMessage(
              this.messages,
              this.optionsSelected.retest_requested,
            );
            break;
          case this.optionsSelected.pay_bounty:
            this.description = this.filterMessage(
              this.messages,
              this.optionsSelected.bounty_paid,
            );
            break;
          case this.optionsSelected.move_to_locker:
            this.description = this.filterMessage(
              this.messages,
              this.optionsSelected.move_to_locker,
            );
            break;
          case this.optionsSelected.move_out_of_locker:
            this.description = this.filterMessage(
              this.messages,
              this.optionsSelected.move_out_of_locker,
            );
            break;
          default:
            this.description = "";
        }
      }
      if (self.description) self.oldDescription = self.description;
    },
    filterMessage(data, description) {
      let filterMessage = data.filter(
        (message) => message.type === description,
      );
      return filterMessage[0]?.message;
    },

    async fetchData() {
      try {
        const { data } = await CompanyService.getMessageDefault();
        this.messages = data ? data : [];
      } catch (error) {
        console.log(error);
      }
    },

    addtags() {
      if (
        ["owner", "administrator"].includes(this.$store.getters["getUser"].role)
      ) {
        this.selectedTags = [];
        this.tags?.forEach((element) => {
          if (this.optionsTags.includes(element)) {
            this.selectedTags.push(element);
          }
        });

        this.$bvModal.show("modal-tags");
      }
    },

    async generatedPDF() {
      var self = this;
      this.$bvModal.hide("modal-password");

      const today = new Date();
      const status = `<strong>${this.$ml.get(
        "status",
      )}:</strong> ${this.$ml.get(this.reportData.status)}`;
      const situation = `<strong>${this.$ml.get(
        "situation",
      )}:</strong> ${this.$ml.get(this.reportData.situation)}`;
      const severity = `<strong>${this.$ml.get(
        "severity",
      )}:</strong> ${this.$ml.get(this.reportData.severity)}`;
      const summary = `<strong>${this.$ml.get("summary")}:</strong> ${
        this.reportData.abstract
      }`;
      const report = `<strong>${this.$ml.get("report")}:</strong> ${
        this.reportData.title
      }`;
      const program = `<strong>${this.$ml.get("program")}:</strong> ${
        this.programData.name
      }`;
      const scope = `<strong>${
        this.reportData.alternativeScope
          ? this.$ml.get("outOfScopeTitle")
          : this.$ml.get("scope")
      }:</strong> ${
        this.reportData.scope_description ?? this.reportData.alternativeScope
      }`;
      const typeScope = `<strong>${this.$ml.get("type")}:</strong> ${
        this.nameLangScope(this.reportData.scope_type) ??
        this.nameLangScope(this.reportData.alternativeScopeType)
      }`;
      const openingDate = `<strong>${this.$ml.get(
        "openingDate",
      )}</strong> ${this.$utils.formatDataShort(this.reportData.createdAt)}`;
      const idReport = `<strong>Id</strong>: ${this.reportData._id}`;
      const extractedBy = `<p><strong>${this.$ml.get(
        "extractedBy",
      )}:</strong> ${
        this.$store.getters["getUser"].name
      } em ${this.$utils.formatDataShort(today)}</p>`;

      const header = `<p style="line-height:1.5;">
      ${idReport}
      <br>
      ${program}
      <br>
      ${report}
      </p>`;
      const resume = `<p style="line-height:1.5;">
      ${openingDate}
      <br>
      ${status}
      <br>
      ${severity}
       <br>
      ${situation}
      <br>
      ${scope}
      <br>
      ${typeScope}
      <br>
      ${summary}
      </p>`;

      const headerTitle = `<div style="margin-top:50px;">
        <h4 style="color: #730ba9; font-size: 34px;">${self.$ml.get(
          "report",
        )}<br> <span style="font-size: 48px; color:black;">${self.$ml.get(
        "securitySystem",
      )}</span></h4>
      </div>`;

      let target = "";

      if (this.reportData.target) {
        let textTarget = this.$utils.convertMarkedOld(
          this.reportData.target.policy,
        );

        target = `
        <div style="line-height:1.2; text-align: justify;">
        <span style="font-size:22px;"><strong>Informações do (Objetivo do Programa)</strong></span>
        <span><strong>Nome:</strong> ${this.reportData.target.title}</span>
        <span><strong>Descrição:</strong>${textTarget}</span>
        </div>`;
      }

      let textHtml = "";

      if (
        this.compareDate(this.reportData.createdAt) ||
        this.reportData.newReport
      ) {
        textHtml = this.$utils.convertMarkedOld(
          this.reportData.encoded_base64
            ? this.decodeBase64(this.reportData.translated_description)
            : this.compareDateTab(
                this.reportData.createdAt,
                this.reportData.translated_description,
              ),
        );

        if (this.reportData.files) {
          var imgExplorar = "";
          for (const element of this.reportData.files) {
            try {
              const { data } = await ReportService.postUrlToBase64(
                element.path,
              );

              let base64String = data;
              let name = element.name;

              if (
                ["jpeg", "png", "jpg"].includes(
                  name.split(".")[name.split(".").length - 1],
                )
              ) {
                imgExplorar += `<br><div class="mb-1"><label class="mb-1 text-danger">${name}</labe><br><img class="img-report-pdf" alt="${name}" src="${base64String}"></div>`;
              } else {
                imgExplorar += `[ ${element.id} ] <br><div class="mb-1"><label class="mb-2">Para baixar o arquivo <label class="text-danger m-0">${name}</label>, acesse a plataforma.</label></a></div>`;
              }
            } catch (error) {
              console.log(error);
            }
          }
        }
      } else {
        textHtml = this.$utils.convertHtml(
          this.showOriginalContract
            ? this.reportData.description
            : this.reportData.translated_description,
        );
      }

      const wayToExplore = `
      <div style="line-height:1.3; text-align: justify;">
        ${textHtml}
        <div style="max-width:600px">${imgExplorar ? imgExplorar : ""}</div>
      </div>`;

      let eventsItems = ``;
      for (const item of this.events) {
        if (item.author_type == "company") {
          eventsItems += `<div>
                        <p style="line-height: 1.5;"><strong style="color: #8c0da1">${
                          item.deleted_author
                            ? this.$store.getters["getCompany"]
                            : item.author
                        }</strong>
                        -
                        `;
        } else {
          eventsItems += `<div>
                        <p><strong style="color: #8c0da1">${
                          item.deleted_author
                            ? this.$ml.get("userRemoved")
                            : item.author
                        }</strong>
                       -
                        `;
        }

        if (item.action == "comment") {
          eventsItems += `${this.$ml.get("postedComment")} ${
            item.visibility != "public"
              ? this.$ml.get("like") + " " + this.$ml.get(item.visibility)
              : ""
          }`;
        }

        if (item.action == "close_report") {
          eventsItems += `${this.$ml.get("closedTheReportAs")} ${this.$ml.get(
            item.new_value,
          )}`;
        }

        if (item.action == "reopen_report") {
          eventsItems += `${this.$ml.get("reopenedTheReport")}`;
        }

        if (item.action == "change_situation") {
          if (item.old_value) {
            eventsItems += `${this.messageMl("changedTheStatusFrom", item)}`;
          } else {
            eventsItems += `${this.messageMl("changedTheSituationTo", item)}`;
          }
        }

        if (item.action == "update_visibility") {
          if (item.old_value) {
            eventsItems += `${this.messageMl("changedTheVisibilityOf", item)}`;
          } else {
            eventsItems += `${this.messageMl("changedTheVisibilityTo", item)}`;
          }
        }

        if (item.action == "update_title") {
          if (item.old_value) {
            eventsItems += `${this.messageMl("changedTheTitleOf", item)}`;
          } else {
            eventsItems += `${this.messageMl("changedTheTitleTo", item)}`;
          }
        }

        if (item.action == "retest") {
          eventsItems += `${this.$ml.get("requestedANewTestOfTheReport")}`;
        }

        if (item.action == "evaluate_retest") {
          eventsItems += `${
            item.new_value == "approved"
              ? this.$ml.get("approvedRetest")
              : this.$ml.get("refusedRetest")
          }`;
        }

        if (item.action == "submit_retest") {
          eventsItems += `${
            item.new_value == "confirmed"
              ? this.$ml.get("reportedThatTheVulnerabilityIsFixed")
              : this.$ml.get("reportedThatTheVulnerabilityIsNotPatched")
          }`;
        }

        if (item.action == "update_severity") {
          if (item.old_value) {
            eventsItems += `
          
            ${this.$ml.get("adjustedTheImpactFrom")}
         
            ${this.$ml.get(item.old_value)}
           
            ${this.$ml.get("to")}

            <span style="color:#730ca8;">${this.$ml.get(item.new_value)}</span>

          `;
          } else {
            eventsItems += `
          <p>
            ${this.$ml.get("adjustedTheImpactTo")}
            <br>
            <img src="../../../src/assets/icons/long-arrow-right.svg" class="ico-15  mx-1 mt-1" />
            <br>
            ${item.new_value}
          </p>
          `;
          }
        }

        if (item.action == "pay_bounty") {
          eventsItems += `${this.$ml.get(
            "requestedPaymentOf",
          )} ${this.$utils.convertMoney(item.new_value)} `;
        }

        if (item.action == "pay_retest") {
          eventsItems += `${this.$ml.get("requestedRetestPayment")} `;
        }

        if (item.action == "retest" && this.reportData.retest_payment) {
          eventsItems += `${this.$ml
            .with(this.reportData.retest_hacker_percentage + " %")
            .get("paidRetest")} `;
        }

        if (item.action == "pay_retest") {
          eventsItems += `<br> ${this.$ml.get("retestId")}:</b>&nbsp;${
            item.retestId
          } <b>${this.$ml.get("value")}<br>&nbsp;${this.$utils.convertMoney(
            item.old_value,
          )}`;
        }

        if (item.action == "close_report") {
          if (item.duplicated.title) {
            eventsItems += `<br>
          <strong>${this.$ml.get("inRelationToTheReport")}:</strong> ${
              item.duplicated.title
            }
          <br>
          <strong>${this.$ml.get("published")}: </strong>${this.$ml
              .with(
                this.$utils.formatData(
                  item.duplicated.sent_at,
                  this.$ml.get("ln"),
                ),
              )
              .get("ago")}
          <br>
          <strong>Status: </strong>${this.$ml.get(item.duplicated.status)} 
          `;
          }
        }

        eventsItems += `<br><strong>Enviado em:</strong> ${this.$utils.formatDataShort(
          item.createdAt,
        )}`;

        let comment = "";

        if (
          this.compareDate(item.createdAt) ||
          item.newComment ||
          this.compareDateComment(item.createdAt)
        ) {
          comment = this.$utils.convertMarkedOld(
            item.encoded_base64
              ? this.decodeBase64(item.message)
              : item.message,
          );
        } else {
          comment = this.$utils.convertHtml(item.translated_message);
        }

        comment += "</base></div>";

        var tagImg = ``;
        if (item.files) {
          for (let img of item.files) {
            try {
              if (
                ["jpeg", "png", "jpg"].includes(
                  img.name.split(".")[img.name.split(".").length - 1],
                )
              ) {
                const { data } = await ReportService.postUrlToBase64(img.path);
                var dataImg = data;
                tagImg += `<div class="mb-4"><div class="mb-1"><label class="text-danger mb-1">${img.name}</labe></div><img style="max-width: 600px;" class="img-report-pdf" alt="${img.name}" src="${dataImg}" ></div> `;
              } else {
                tagImg += `<div class="mb-4">[${img.id}] <br><label class="mb-0">Para baixar o arquivo<label class="text-danger m-0">${img.name}</label>, acesse a plataforma.</label></a></div>`;
              }
            } catch (error) {
              console.log(error);
            }
          }
        }

        if (item.message) {
          const maxCharactersPerParagraph = 65;
          let currentIndex = 0;
          let formattedComment = "";

          while (currentIndex < comment.length) {
            const currentParagraph = comment.substr(
              currentIndex,
              maxCharactersPerParagraph,
            );

            if (currentParagraph.length > 50 && !/\s/.test(currentParagraph)) {
              formattedComment += `<p>${currentParagraph}</p>`;
              currentIndex += currentParagraph.length;
            } else {
              formattedComment += currentParagraph.trim(" ");
              currentIndex += currentParagraph.length;
            }
          }
          eventsItems += `
                <br>
                <strong>Comentário:</strong>
                ${formattedComment}              
                ${tagImg ? tagImg : ""}
            `;
        }
        eventsItems += `<hr></div>`;
      }

      // Converta o HTML para o formato do pdfmake
      const headerConveted = htmlToPdfmake(header);
      const headerTitleConverted = htmlToPdfmake(headerTitle);
      const wayToExploreConverted = htmlToPdfmake(wayToExplore);
      const resumeConveted = htmlToPdfmake(resume);
      const extractedByConverted = htmlToPdfmake(extractedBy);
      const eventsItemsConverted = this.downloadWithEvent
        ? htmlToPdfmake(eventsItems)
        : null;
      const targetConverted = htmlToPdfmake(target);

      function getEventItems() {
        if (eventsItemsConverted && eventsItemsConverted.length > 0) {
          return { stack: eventsItemsConverted };
        }
        return null;
      }

      function getTarget() {
        if (targetConverted && targetConverted.length > 0) {
          return { stack: targetConverted };
        }
        return null;
      }

      const documentDefinition = {
        header: function (currentPage, pageCount) {
          if (currentPage !== 1 && currentPage !== pageCount) {
            return {
              stack: [
                {
                  canvas: [
                    {
                      type: "line",
                      x1: 0,
                      y1: 5,
                      x2: 595.28,
                      y2: 5,
                      lineWidth: 10,
                      lineColor: "#730ca8",
                    },
                  ],
                },
                {
                  image: images.logoPdf,
                  width: 70,
                  alignment: "right",
                  margin: [0, 15, -15, 0],
                },
              ],
              margin: [0, 0, 40, 0], // Margem do header
            };
          } else {
            return {
              stack: [
                {
                  canvas: [
                    {
                      type: "line",
                      x1: 0,
                      y1: 5,
                      x2: 595.28,
                      y2: 5,
                      lineWidth: 10,
                      lineColor: "#730ca8",
                    },
                  ],
                },
              ],
              margin: [0, 0, 40, 0], // Margem do header
            };
          }
        },

        content: [
          {
            columns: [{ width: "100%", stack: headerTitleConverted }],
          },
          {
            columns: [
              { width: "100%", stack: headerConveted, pageBreak: "after" },
            ],
          },
          { stack: resumeConveted },
          {
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    text: "Formas de Explorar",
                    // fillColor: '#eeeeee',
                    fontSize: 18,
                    bold: true,
                  },
                ],
              ],
            },
            layout: "noBorders",
          },
          { stack: wayToExploreConverted },
          getTarget(),
          getEventItems(),
          { stack: extractedByConverted },
        ],
        permissions: {
          printing: "highResolution",
          modifying: false,
          copying: false,
          annotating: false,
          fillingForms: false,
          contentAccessibility: false,
          documentAssembly: false,
        },
        userPassword: this.passwordPdf,
        styles: {
          footerConfidential: {
            fontSize: 10,
            color: "red",
          },
          anotherStyle: {
            alignment: "center",
          },
          paragraph: {
            margin: [10, 5, 0, 5],
          },
        },
        footer: function (currentPage, pageCount) {
          return {
            columns: [
              {
                text: self.$ml.get("reportConfidential"),
                alignment: "left",
                margin: [20, 0],
                style: "footerConfidential",
              },
              {
                text: currentPage.toString() + "/" + pageCount,
                alignment: "right",
                margin: [20, 0],
              },
            ],
            margin: [0, 22, 0, 20],
          };
        },
      };
      const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
      pdfDocGenerator.download("report.pdf");
    },

    changeTags() {
      this.optionsTags = [];
      CompanyService.getTags().then((response) => {
        this.optionsTags = response.data?.settings?.report_tags?.map(
          (tag) => tag,
        );
      });
    },

    resetLink() {
      this.tokenRecaptcha = "";
      this.linkTarget = "";
      this.tokenRecaptchaModal = "";
    },

    linkExternal(e) {
      var self = this;
      const element = e.target;
      if (
        element.tagName == "A" &&
        element.getAttribute("class") &&
        element.getAttribute("class").includes("link-download")
      ) {
        return;
      }
      if (element.tagName == "A" && element.getAttribute("href")) {
        e.preventDefault();
        self.linkTarget = element.getAttribute("href");
        self.$bvModal.show("modal-link");
      }
    },

    mathAbsMoney() {
      this.itemSelected.id = Math.abs(this.itemSelected.id);
    },

    nameLang({ name }) {
      return `${this.$ml.get(name)}`;
    },

    nameLangScope(name) {
      if (!["-"].includes(name) && name) {
        return this.$ml.get(name.replaceAll("-", ""));
      }
      return name;
    },

    controlTextArea() {
      if (this.description.length > 5000) {
        this.description = this.description.substring(0, 5000);
        this.descriptionMaxLengt = true;
      } else {
        this.descriptionMaxLengt = false;
      }
    },
    startTimer() {
      this.duration = 50;
      let timer = this.duration;

      let interval = setInterval(() => {
        if (--timer < 0) {
          clearInterval(interval);
          this.duration = 0;
          Swal.close();
        }
      }, 1000);
    },
    triggerEvent() {
      window.grecaptcha.reset();

      setTimeout(() => {
        this.buttonForSaveEvent++;
      }, 500);

      var self = this;
      if (
        this.pendingRetest &&
        this.actionSelected === "close_report" &&
        this.itemSelected.id === "approved"
      ) {
        this.startTimer();
        return Swal.fire({
          icon: "info",
          html: `<h4>${this.$ml.get("approveWithoutRetest")}</h4`,
          showDenyButton: true,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: this.$ml.get("requestRetest"),
          cancelButtonText: this.$ml.get("cancel"),
          denyButtonText: this.$ml.get("continue"),
          denyButtonColor: "#757575",
        })
          .then((result) => {
            if (result.isConfirmed) {
              self.actionSelected = self.itensAction.filter(
                (item) => item === "retest",
              )[0];
              self.alterItens();
            }
            if (result.isDismissed) {
              this.tokenRecaptcha = "";
              return { cancelCloseReport: true };
            }
            return { cancelCloseReport: false };
          })
          .then((response) => {
            console.log(response);
            if (!response.cancelCloseReport) {
              self.verifyEvent();
            }
          });
      }
      return self.verifyEvent();
    },

    compareDateTab(date, description) {
      if (
        moment(date).isBefore("2022-06-06") &&
        moment(date).isAfter("2022-05-17")
      ) {
        return description.replace(/^[^\S+\n]+/gm, "");
      }

      return description;
    },

    compareDate(date) {
      if (moment(date).isBefore(process.env.VUE_APP_DESCRIPTIONOLD))
        return true;
    },

    compareDateComment(date) {
      let dateItem = new Date(date);
      let dateNewComponent = new Date("2021-09-19T19:17:57.632+00:00");

      if (moment(dateItem).isAfter(Date.parse(dateNewComponent))) return true;
    },

    messageMl(message, item) {
      let msg = "";
      let new_value = this.$ml.get(item.new_value);

      switch (message) {
        case "changedTheStatusFrom":
          msg = this.$ml
            .with("f", this.$ml.get(item.old_value))
            .with("l", new_value)
            .get(message);
          break;
        case "changedTheSituationTo":
          msg = this.$ml.with(new_value).get(message);
          break;
        case "changedTheVisibilityOf":
          msg = this.$ml
            .with("f", this.$ml.get(item.old_value))
            .with("l", new_value)
            .get(message);
          break;
        case "changedTheVisibilityTo":
          msg = this.$ml.with(new_value).get(message);
          break;
        case "changedTheTitleOf":
          msg = this.$ml
            .with("f", this.$ml.get(item.old_value))
            .with("l", new_value)
            .get(message);
          break;
        case "changedTheTitleTo":
          msg = this.$ml.with(new_value).get(message);
          break;
      }

      return msg;
    },

    changeLanguage(ln) {
      ProgramService.postPreferredLanguage(ln);
    },

    changeProgram(id) {
      ProgramService.getProgramDetail(id).then((response) => {
        let payBounty = null;
        this.currency = response.data?.currency?.toUpperCase() ?? "BRL";
        this.itensAction.forEach((element, index) => {
          if (response.data.type == "vdp" && element == "pay_bounty") {
            payBounty = index;
          }
        });

        if (payBounty) this.itensAction.splice(payBounty, 1);

        this.listDuplicateEscope = response.data.scope;
        this.programData = response.data;
        this.programData.id = id;

        this.target_settings = response.data?.target_settings;

        setTimeout(() => {
          if (
            this.$store.getters["getUserType"] == "hacker" &&
            this.reportData.status == "closed" &&
            !this.requestedReview
          ) {
            this.itensAction = ["comment", "request_review"];
          }
        }, 1000);
      });
    },

    formartObj(data) {
      return data.map((i) => ({ ...i, show_original_comment: false }));
    },

    async changeReport(id, down) {
      this.pending_retest_submission = false;

      console.log("route", this.$route.fullPath.split("?")[0] + "?" + id);

      window.history.replaceState(
        null,
        null,
        this.$route.fullPath.split("?")[0] + "?" + id,
      );
      this.loading = true;

      await this.resetVars();

      const payload = {
        locker: true,
        locker_jwt: localStorage.getItem("token_safe"),
      };

      ReportService.getReportDetail(id, payload).then(
        async (response) => {
          this.loading = false;
          this.reportData = response.data.report_data[0];
          (this.cvss = this.reportData.cvss),
            (this.cvssScore = this.reportData.cvssScore),
            (this.events = this.formartObj(response.data.events));
          this.requestedReview = this.events.some((item) =>
            item.action.includes("request_review"),
          );
          this.pendingRetest = response.data.pending_retest;
          this.possibleDup = response.data.possible_dup;
          this.possibleSpam = response.data.possible_spam;
          this.reportcreatedAt = response.data.report_data[0].createdAt;
          this.actionSelected = "comment";
          this.tags = response.data.report_data[0].tags;
          this.payment_status = response?.data?.payment_status[0];
          this.isHackerOnHof = response?.data?.report_data[0].isHackerOnHof;
          this.programActiveHof =
            response?.data?.report_data[0].programActiveHof;
          this.hacker_username =
            response?.data?.report_data[0]?.hacker_username;
          this.target = response.data?.report_data[0].target;
          this.sugested_bounty = response.data?.report_data[0]?.sugested_bounty;
          this.active_campaign = response.data?.report_data[0]?.active_campaign;
          this.double_bounty = response.data?.report_data[0]?.double_bounty;
          this.double_score = response.data?.report_data[0]?.double_score;
          await this.alterItens();

          if (
            this.reportData.requestedBountyPayment ||
            ["analyst"].includes(this.$store.getters["getUser"].role)
          ) {
            this.itensAction = [
              "comment",
              "change_situation",
              "update_severity",
              "request_update",
              "retest",
              "close_report",
              "reopen_report",
            ];
          }

          // Início das regras do reteste
          let indexEvent = "";

          this.events.forEach((element, index) => {
            if (element.action == "retest") {
              indexEvent = index;
            }
          });

          if (this.events[indexEvent]) {
            let lastRetest = this.events[indexEvent];

            if (
              lastRetest.retest_approved_by_company && // Reteste aprovado pela empresa
              !lastRetest.retest_confirmed_by_hacker
            ) {
              // Reteste não confirmado pelo hacker
              // Adiciona o reteste
              this.itensAction.push("retest");
              // Remove a avaliação do reteste
              if (this.itensAction.indexOf("evaluate_retest") != -1) {
                this.itensAction.splice(
                  this.itensAction.indexOf("evaluate_retest"),
                  1,
                );
              }
            } else {
              // Adiciona a avaliação do reteste
              this.itensAction.push("evaluate_retest");
              // Remove o reteste
              // if (this.itensAction.indexOf("retest") != -1) {
              //   this.itensAction.splice(this.itensAction.indexOf("retest"), 1);
              // }
            }

            // Se não tiver pendente a avaliação do reteste
            if (
              !lastRetest.pending_retest_evaluation &&
              this.itensAction.indexOf("evaluate_retest") != -1
            ) {
              // Remove a avaliação do reteste
              this.itensAction.splice(
                this.itensAction.indexOf("evaluate_retest"),
                1,
              );
            }

            // Para o hacker
            this.pending_retest_evaluation =
              lastRetest.pending_retest_evaluation;
            this.pending_retest_submission =
              lastRetest.pending_retest_submission;

            // Fim das regras do reteste
          }

          if (this.reportData.status == "closed") {
            let array = [];
            await this.itensAction.forEach((element) => {
              if (
                ![
                  "change_situation",
                  "close_report",
                  "retest",
                  "update_severity",
                  "request_update",
                ].includes(element)
              ) {
                array.push(element);
              }
            });
            this.itensAction = array;
          }

          if (this.reportData.locker == true) {
            this.itensAction.splice(
              this.itensAction.indexOf("move_to_locker"),
              1,
            );
          } else {
            this.itensAction.splice(
              this.itensAction.indexOf("move_out_of_locker"),
              1,
            );
          }

          if (this.reportData.status == "open") {
            let array = [];
            await this.itensAction.forEach((element) => {
              if (!["reopen_report"].includes(element)) {
                array.push(element);
              }
            });
            this.itensAction = array;
          }

          if (down) {
            $("html, body").animate(
              { scrollTop: document.body.scrollHeight },
              "5000",
            );
          } else {
            $("html, body").animate({ scrollTop: 0 }, "5000");
          }
          this.changeProgram(this.reportData.program);
        },
        () => {
          this.loading = false;
          this.$router.push("/reportLocker");
        },
      );
    },

    nameWithLang({ title, _id }) {
      return `${title + " - " + _id} `;
    },

    changeReportsDuplicate(txtSearch) {
      let payload = "";

      if (txtSearch && txtSearch != " ") {
        this.txtSearchDuplicated = txtSearch;
        this.errorSelectDuplicated = false;
        payload += `&search=${txtSearch}`;
      } else {
        payload += `&search=${this.txtSearchDuplicated}`;
      }

      if (this.btnToggle && this.scopeDuplicateSelected._id) {
        payload += `&scope=${this.scopeDuplicateSelected._id}`;
      }

      if (this.btnToggle && this.selectedThreat._id) {
        payload += `&weakness=${this.selectedThreat._id}`;
      }

      ReportService.getReportsDuplicate(this.reportData._id, 5, payload).then(
        (response) => {
          this.listDuplicateReport = response.data;
        },
        () => {
          this.loadingBtn = false;
        },
      );
    },

    changeListReport(search) {
      this.loadingReport = true;
      this.listReports = [];

      let payload = "";

      if (search) {
        payload += `&search=${search}`;
      }

      ReportService.getListReports(1, 10, payload, "", {
        locker: true,
        locker_jwt: localStorage.getItem("token_safe"),
        showAll: true,
      }).then(
        (response) => {
          this.loadingReport = false;
          this.listReports = response.data.items;
        },
        () => {
          this.loadingReport = false;
        },
      );
    },

    changeWeakness(desc) {
      ReportService.getWeakness(desc, 7).then((response) => {
        this.selectThreat = response.data;
      });
    },

    async verifyEvent() {
      var self = this;

      this.$v.$touch();
      this.error = false;
      this.upload_error = false;

      if (
        ["comment", "submit_retest", "request_review"].includes(
          this.actionSelected,
        ) &&
        this.$v.description.$error
      ) {
        this.error = true;
        return;
      }

      this.errorPayBounty = false;

      this.formData = new FormData();

      if (this.actionSelected == "pay_bounty" && !this.itemSelected.id) {
        this.errorPayBounty = true;
        return;
      }

      this.listFiles.forEach((element) => {
        this.formData.append("files", element);
      });

      if (this.actionSelected == "comment") {
        this.formData.append(
          "visibility",
          this.itemSelected.id ? this.itemSelected.id : "private",
        );
      } else {
        this.formData.append("visibility", "private");
      }

      if (this.reportData.locker == true) {
        console.log(
          "🚀 ~ verifyEvent ~ this.reportData.locker:",
          this.reportData.locker,
        );
        const lockerCredentials = {
          locker: true,
          locker_jwt: localStorage.getItem("token_safe"),
        };
        console.log("🚀 ~ verifyEvent ~ lockerCredentials:", lockerCredentials);
        this.formData.append("locker", lockerCredentials.locker);
        this.formData.append("locker_jwt", lockerCredentials.locker_jwt);
      }

      this.formData.append("report", this.reportData._id);

      this.formData.append(
        "action",
        this.actionSelected ? this.actionSelected : "comment",
      );

      this.formData.append("tokenRecaptcha", this.tokenRecaptcha);

      if (this.description) {
        this.formData.append(
          "message",
          this.$utils.utf8_to_b64(this.description),
        );
      }

      if (
        ![
          "comment",
          "evaluate_retest",
          "submit_retest",
          "request_review",
        ].includes(this.actionSelected)
      )
        this.formData.append("value", this.itemSelected.id);

      if (["evaluate_retest"].includes(this.actionSelected)) {
        this.formData.append("retest_status", this.itemSelected.id);
      }

      if (["submit_retest"].includes(this.actionSelected)) {
        this.formData.append("retest_status", this.retest_status);
      }

      this.errorSelectDuplicated = false;
      if (
        this.itemSelected.id == "duplicated" &&
        !this.reportDuplicateSelected._id
      ) {
        this.errorSelectDuplicated = true;
        return;
      }

      if (this.itemSelected.id == "duplicated") {
        this.formData.append(
          "duplicatedFrom",
          this.reportDuplicateSelected._id,
        );
      }

      if (
        ["approved", "duplicated", "informative"].includes(
          this.itemSelected.id,
        ) &&
        this.actionSelected != "evaluate_retest"
      ) {
        "accepted", "duplicated", "informative";
        this.scope_type = this.reportData.scope_type || "";
        this.writing_evaluation = 10;
        self.$bvModal.show("modal-analysis");
        return;
      } else {
        this.saveEventReport();
      }
    },

    saveEventReport() {
      var self = this;
      this.loadingBtn = true;

      if (this.actionSelected == "close_report") {
        this.formData.append(
          "writing_evaluation",
          Number(this.writing_evaluation),
        );
        this.formData.append("scope_type", this.scope_type);
      }

      if (this.target_settings?.active) {
        this.formData.append("target_finished", this.target_selected);
      }

      // if (this.programActiveHof && !this.isHackerOnHof) {
      //   return Swal.fire({
      //     icon: "info",
      //     html: `<h4>${this.$ml.get("addHackerToHof")}</h4`,
      //     showCancelButton: true,
      //     showConfirmButton: true,
      //     confirmButtonText: this.$ml.get("yes"),
      //     cancelButtonText: this.$ml.get("no"),
      //     confirmButtonColor: "#730BA9",
      //   }).then((result) => {
      //     if (result.isConfirmed) {
      //       this.addHackerToHof = true;
      //     }
      //   });
      // }

      this.formData.append(
        "addToHof",
        this.addHackerToHof == true ? "yes" : "no",
      );

      ReportService.postEventReport(this.formData)
        .then((resp) => {
          this.htmlText = false;
          this.$bvModal.hide("modal-analysis");
          this.description = "";
          this.listFiles = [];
          this.reportDuplicateSelected = [];
          this.changeReport(this.reportData._id, "down");
          this.loadingBtn = false;

          if (resp.status === 201 && this.actionSelected != "comment") {
            this.changeListReport();
          }

          if (
            this.$store.getters["getUserType"] == "hacker" &&
            !["comment", "move_out_of_locker"].includes(resp.data.action)
          ) {
            Swal.fire({
              icon: "success",
              title: self.$ml.get("requestSent"),
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
          } else if (resp.data.action == "move_out_of_locker") {
            this.$router.push(`/report/details?${this.reportData._id}`);
          }
          this.$refs.recaptcha.resetRecaptcha();
          self.tokenRecaptcha = "";
        })
        .catch((error) => {
          self.$refs.recaptcha.resetRecaptcha();
          self.tokenRecaptcha = "";
          self.loadingBtn = false;

          if (
            error.response?.data?.message[0] ===
            "O token do cofre não é válido!"
          ) {
            Swal.fire({
              icon: "warning",
              title: self.$ml.get("expiredLockerSwal"),
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });

            setTimeout(() => self.$router.push("/reportLocker"), 3000);
            return;
          }
          this.$bvModal.hide("modal-analysis");

          if (error.response?.data?.statusCode == 425) {
            Swal.fire({
              icon: "info",
              title: self.$ml.get("notAuthorized"),
              showConfirmButton: false,
              timer: 5000,
            });
            return;
          }
          if (error.response?.data?.statusCode == 422) {
            const ACTION_ALREADY_REPORTED_MESSAGE = "Ação já reportada!";

            if (
              error.response?.data?.message === ACTION_ALREADY_REPORTED_MESSAGE
            ) {
              Swal.fire({
                icon: "info",
                title: self.$ml.get("actionAlreadyReported"),
                showConfirmButton: false,
                timer: 5000,
              });
              return;
            }

            let errorMessage =
              "Uma solicitação de resposta deste relatório já foi solicitada!";

            Swal.fire({
              icon: "info",
              title:
                error.response?.data?.message == errorMessage
                  ? self.$ml.get("replyRequestMessage")
                  : self.$ml.get("shutdownRequested"),
              showConfirmButton: false,
              timer: 5000,
            });
            return;
          }

          if (error.response?.data?.message) {
            let msgErr = error.response.data.message;

            if (Array.isArray(error.response.data.message)) {
              msgErr = error.response.data.message[0];
            }

            switch (msgErr) {
              case "O arquivo não é válido!":
                msgErr = self.$ml.get("theFileIsNotValid");
                break;

              case "O reteste não foi submetido!":
                msgErr = self.$ml.get("theRetestWasNotSubmitted");
                break;

              case "O reteste já foi aceito!":
                msgErr = self.$ml.get("theRetestHaAlreadyAccepted");
                break;

              case "Não foi possível submeter a avaliação do reteste!":
                msgErr = self.$ml.get("itIsNotPossibleToSubmitAnotherRetest");
                break;

              default:
                msgErr = self.$ml.get("unableToCompleteThisRequest");
                break;
            }

            Swal.fire({
              icon: "info",
              html: `<h4>${msgErr}</h4`,
              showConfirmButton: false,
              timer: 10000,
            });

            return;
          }

          Swal.fire({
            icon: "info",
            html: `<h4>${self.$ml.get("doNotUseSpecialCharacters")}</h4`,
            showConfirmButton: false,
            timer: 10000,
          });
        });
    },

    alterItens() {
      switch (this.actionSelected) {
        case "comment":
          this.itensSelect = this.itensComment;
          this.itemSelected = { name: "private", id: "private" };
          break;
        case "request_review":
          this.itensSelect = this.itensComment;
          this.itemSelected = { name: "private", id: "private" };
          break;
        case "change_situation":
          this.itensSelect = this.itensSituation;
          this.itemSelected = {
            name: "needs_information",
            id: "needs_information",
          };
          break;
        case "update_severity":
          this.itensSelect = this.itensSeverity;
          this.itemSelected = { name: "critical", id: "critical" };
          break;
        case "request_update":
          this.itensSelect = this.itensUpdate;
          this.itemSelected = { name: "request_closure", id: "closure" };
          break;
        case "close_report":
          this.itensSelect = this.itensCloseReport;
          this.itemSelected = { name: "approved", id: "approved" };
          break;
        case "evaluate_retest":
          this.itensSelect = this.itensChangeSituation;
          this.itemSelected = { name: "approved", id: "approved" };
          break;

        default:
          this.itensSelect = this.itensComment;
          this.itemSelected = { name: "public", id: "public" };
      }
    },

    alterTag() {
      this.loadingBtn = true;

      ReportService.putTags(this.reportData._id, {
        tags: this.selectedTags?.map((tag) => tag),
      })
        .then(() => {
          this.$bvModal.hide("modal-tags");
          this.changeReport(this.reportData._id);
          this.loadingBtn = false;
        })
        .catch((error) => {
          console.dir(error);
          this.loadingBtn = false;
          this.$bvModal.hide("modal-tags");

          if (error.response?.data?.statusCode == 425) {
            Swal.fire({
              icon: "info",
              title: self.$ml.get("notAuthorized"),
              showConfirmButton: false,
              timer: 5000,
            });
            return;
          }

          if (error.response?.data?.message) {
            let msgErr = error.response.data.message;

            if (Array.isArray(error.response.data.message)) {
              msgErr = error.response.data.message[0];
            }

            switch (msgErr) {
              case "O arquivo não é válido!":
                msgErr = self.$ml.get("theFileIsNotValid");
                break;
              default:
                msgErr = self.$ml.get("unableToCompleteThisRequest");
                break;
            }

            Swal.fire({
              icon: "info",
              html: `<h4>${msgErr}</h4`,
              showConfirmButton: false,
              timer: 10000,
            });

            return;
          }

          Swal.fire({
            icon: "info",
            html: `<h4>${self.$ml.get("doNotUseSpecialCharacters")}</h4`,
            showConfirmButton: false,
            timer: 10000,
          });
        });
    },

    removeFile(item) {
      document.getElementById("files").value = "";
      this.listFiles.splice(item, 1);
    },

    initUpFile(files) {
      var self = this;

      if (files) {
        if (files.length + self.listFiles.length > 10) {
          document.getElementById("files").value = "";

          Swal.fire({
            heightAuto: false,
            html: `<h4 class="mb-1">${self.$ml.get(
              "maximumFilesPerComment",
            )}</h4>
                  <label>
                   ${self.$ml.get("ifYouNeedToSubmitMoreComment")}
                  </label>
                  `,
            customClass: "swal-2fa",
            showCancelButton: false,
            confirmButtonText: self.$ml.get("return"),
            confirmButtonColor: "#730BA9",
          });

          return;
        }

        this.upload_error = false;

        Array.from(files).forEach((element, index) => {
          if (this.$utils.uploadVerify(element)) {
            this.upload_error = this.$utils.uploadVerify(element);
            return;
          }

          let fileSize = element.size.toString();
          let sizeFormat = "";

          if (fileSize.length < 7) {
            sizeFormat = `${Math.round(+fileSize / 1024).toFixed(2)}kb`;
          } else {
            sizeFormat = `${(Math.round(+fileSize / 1024) / 1000).toFixed(
              2,
            )}MB`;
          }

          let id =
            "F" + String(element.lastModified * (index + 3)).substr(4, 4);
          let originalName = element.name;

          let name = JSON.stringify({
            id: id,
            sizeFormat: sizeFormat,
            name: element.name,
          });

          element = new File([element], name, {
            type: element.type,
          });

          element.id = id;
          element.sizeFormat = sizeFormat;
          element.originalName = originalName;

          self.listFiles.push(element);
        });
      }
    },

    viewHtml() {
      this.htmlText = "";
      this.htmlText = this.$utils.convertMarkedOld(
        this.description,
        this.listFiles,
      );
    },

    copyLink(id) {
      var hiddenField = document.getElementById("input" + id);
      hiddenField.select();
      document.execCommand("copy");
      this.textTolltip = this.$ml.get(
        "pasteTheLinkIntoTheBodyOfTheDescription",
      );
    },

    resetVars() {
      this.itensAction = [
        "comment",
        "change_situation",
        "update_severity",
        "request_update",
        "retest",
        "pay_bounty",
        "close_report",
        "reopen_report",
      ];
    },

    copyIdReport() {
      var self = this;

      var hiddenField = document.getElementById("inputIdReport");
      hiddenField.select();
      document.execCommand("copy");

      Swal.fire({
        icon: "info",
        title: self.$ml.get("copiedId"),
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
      });
    },

    setRecaptchaToken(token, tokenModal) {
      if (tokenModal === "modal") {
        this.tokenRecaptchaModal = token;
        this.tokenRecaptcha = this.tokenRecaptchaModal;
      } else {
        this.tokenRecaptcha = token;
      }
    },
  },
};
</script>
<style scoped>
.login-ico {
  position: absolute;
  right: 7px;
  top: 15%;
}
.icon-header {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 4px;
  background-color: #730ba9;
}
.info-modal-pdf {
  display: flex;
  gap: 5px;
  background: #fffaeb;
  border: 1px solid #fde68a9d;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 14px;
  color: #a25a31;
}
.info-modal-pdf > p {
  max-width: 300px;
}
.box-check {
  padding: 6px 0px;
  border: 1px solid #e5e5e580;
  border-radius: 6px;
  background: #fcfcfc;
}
.desc-events {
  margin-bottom: 0px;
  margin-left: 36px;
  font-size: 14px;
  color: #a3a3a3;
  max-width: 359px;
}

/*Custom checkboxes style*/
.custom-checkbox input[type="checkbox"] + .label-text:before {
  content: "";
  text-transform: none;
  line-height: 0.8;
  display: inline-block;
  border-radius: 3px;
  border: #730ca8 1px solid;
  padding: 7px;
  position: absolute;
}
.custom-checkbox input[type="checkbox"]:checked + .label-text:before {
  content: "✓";
  color: #730ca8;
  border: #730ca8 1px solid;
  animation: effect 250ms ease-in;
  padding: 1px;
}
</style>
<style lang="scss">
.btn-primary:active {
  background-color: #740ca8ab !important;
}
.btn-outline-extra:active {
  background-color: #f2eff3e7 !important;
}
#modal-analysis {
  label {
    padding-top: 3px !important;
  }
  .custom-control-inline {
    margin-right: 0.7rem;
  }
}
.b-form-tags.focus {
  border-color: #730ba9 !important;
  box-shadow: none !important;
}

.inputTags {
  background-color: white;
  input {
    background: rgb(255, 255, 255);
    border-radius: 0;
    box-shadow: none !important;
  }
  .badge-primary {
    color: #8a0ba9;
    background: #cccccc00;
    padding: 3px 4px;
    font-size: 13px;
    font-weight: 500;
    border: 1px solid #8a0ba9;
    margin-right: 10px;
    margin-top: 10px;
    border-radius: 5px;
  }
  .btn {
    padding: 3px 6px 3px !important;
    color: #fff !important;
    background-color: #730ba9;

    margin-bottom: 1px;
  }
}
</style>
<style scoped>
.ico-view-report {
  font-size: 24px;
}

.bg-ranking {
  background-color: #d3d3d3;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: 500;
}

.selected {
  border-right: 4px solid rgba(132, 132, 132, 0.204);
  border-radius: 8px;
  margin-right: -7px;
  padding-right: 10px;
}

#severity-icon-report {
  margin-left: 6px;
}

#childFilter {
  height: calc(100vh - 100px) !important;
  scroll-behavior: auto !important;
  overflow-y: scroll;
}

#childFilter::-webkit-scrollbar-track {
  background-color: #f5f5f5;
}

#childFilter::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}

#childFilter::-webkit-scrollbar-thumb {
  background-color: #0000002f;
  border-radius: 10px;
}

#icoCloseToggle {
  position: absolute;
  left: -35px;
  top: 10px;
}
</style>
<style lang="scss">
body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {
  overflow-y: visible !important;
}

.comment-img {
  div {
    word-break: break-word;
  }
  img {
    border-radius: 0 !important;
    cursor: pointer;
    max-height: 140px !important;
    max-width: 190px !important;
  }

  a {
    font-size: 0.9rem !important;
    color: #dc3545 !important;
  }
}

.float-right:disabled {
  background-color: #6f42c1 !important;
}

.rowAction {
  font {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 14.4px;
  }
}

.area-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin: 0px 8px 0px 6px;
}

.detail-icon-button {
  width: 20px;
  height: 19px;
  display: flex;
  justify-content: center !important;
  align-content: center !important;
  align-items: center !important;
  border-radius: 5px;
}
.ico-btn {
  width: auto;
  height: auto;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  border-radius: 5px;
}

.img-ico-btn {
  width: 30px;
  height: 20px;
  align-self: center;
}
.icon-contract {
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 0px;
}
.icon-summary {
  cursor: pointer;
  position: absolute;
  top: -6px;
  right: -18px;
}
.icon-comment {
  cursor: pointer;
  position: absolute;
  top: 2px;
  right: -4px;
}

.currency {
  position: absolute;
  left: 0px;
  top: -2.6px;
  transform: translate(6px, 67.7%);
  font-weight: 400;
  color: #495057;
}
.real {
  transform: translate(15px, 67.7%);
}
.title-width {
  max-width: 800px;
}
.limit-container {
  width: 95%;
}
.c-double-bounty {
  max-width: 210px;
  background: #f7f8f9;
  border-radius: 4px;
  padding: 0px 5px;
}
.lblWarning {
  color: #730ba9;
  font-size: 12px;
}
@media (max-width: 1578px) {
  .limit-container {
    width: 93.5%;
  }
}
</style>
